// material-ui
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  Grid,
  MenuItem,
  Select,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import InfoIcon from '@material-ui/icons/Info';
import { cloneDeep, isEqual } from 'lodash-es';
import { MTableToolbar } from 'material-table';
import moment from 'moment';
import React, { ChangeEvent, ReactElement } from 'react';

import { getSmallSites } from '~/src/dash/api/channels/channels_methods';
import { ISmallSite } from '~/src/dash/api/channels/channels_models';
// apis
import {
  EAllowStatus,
  ICountryGroup,
  ResourceActiveDisabled,
  ResourceActiveEnabled,
  ResourceActiveUnknown,
  TargetBoolTypeAll,
  TargetingCCPAAll,
  TargetingCoppaAll,
  TargetingLogicAND,
  TargetingLogicOR,
} from '~/src/dash/api/console-api';
import {
  commonRegionGroupsIDs,
  createCountryGroup,
  deleteCountryGroup,
  getCountryGroupsByIDs,
  getCountryGroupsByPublisherID,
  updateCountryGroup,
} from '~/src/dash/api/country-group';
import {
  createInventoryRoute,
  deleteInventoryRoute,
  destinationDemandSourceTypeToString,
  DestinationInclusionFieldKeys,
  DestinationLocalTargetingParams,
  DestinationMenuLists,
  DestinationTargetFieldKeys,
  DestinationType,
  DestinationTypeRoute,
  DestinationTypeSite,
  DestinationTypeVastURL,
  filterInventoryRoutesByActive,
  genInvenRouteChannelListFromSelected,
  genInvenRouteRouteListFromSelected,
  IDestination,
  IInventoryRoute,
  inventoryRouteConditionTypeToString,
  RoutingCondition,
  RoutingConditionPercentageRequests,
  RoutingConditionTargetingParams,
  TargetingLivestreamAll,
  transformInventoryRoute,
  updateInventoryRoute,
} from '~/src/dash/api/inventory_routes';
import {
  generalGetLiveLogs,
  getDestinationEndpointRequestQuery,
  getDestinationEndpointResponseQuery,
  getInventoryRouteEndpointRequestQuery,
  getInventoryRouteEndpointResponseQuery,
} from '~/src/dash/api/live_logs/controller';
import { filterLiveLogs } from '~/src/dash/api/live_logs/helpers';
import {
  IDestinationRequestData,
  IDestinationResponseData,
  IInventoryRouteRequestData,
  IInventoryRouteResponseData,
} from '~/src/dash/api/live_logs/models';
import { IParam } from '~/src/dash/api/network';
import { EBool } from '~/src/dash/api/types/bool';
import { IAccordionPanel, MultiAccordion } from '~/src/dash/components/accordion/multi-accordion';
import { CopyButton } from '~/src/dash/components/button';
import { BlueBackground } from '~/src/dash/components/editor';
import { EndpointBuilder } from '~/src/dash/components/endpointBuilder';
import { FocusedTextfield } from '~/src/dash/components/focused-textfield';
import InputGridRow from '~/src/dash/components/input-grid-row';
import { IInputRow, InputRow, ITabRow } from '~/src/dash/components/input-row';
import {
  ICountryGroupRowData,
  IListTableColumn,
  ListTable,
} from '~/src/dash/components/list-table';
import {} from '~/src/dash/components/live_logs/live_logs_wrapper';
import { LiveLogsWrapper } from '~/src/dash/components/live_logs/live_logs_wrapper';
import { LiveLogsGeneralTable } from '~/src/dash/components/live_logs/live-logs-general-table';
import { LiveData } from '~/src/dash/components/live-data/live-data';
import {
  ILocalTargetingParameter,
  LocalTargeting,
  validateLocalTargeting,
} from '~/src/dash/components/local-targeting/local-targeting';
// components
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { ModelPrimaryContainerV2 } from '~/src/dash/components/model-grid-container-v2';
import { ModelSecondaryButton } from '~/src/dash/components/model-secondary-button';
import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { ModernTextField } from '~/src/dash/components/modern-text-field';
import { ModelParagraphSubtitle } from '~/src/dash/components/paragraph';
import PillSwitcher, { IPillItem } from '~/src/dash/components/pill-switcher';
import { SettingsAppBar } from '~/src/dash/components/settings-app-bar';
import { ITab, SettingsTabs } from '~/src/dash/components/settings-tabs';
import { checkURL, VastEditor } from '~/src/dash/components/vast-editor';
// other
import { getEndpointBuilderServiceRoute } from '~/src/dash/endpoint-builder-configs/inventory-route-settings-list';
import { Panel, Panels } from '~/src/dash/publicaUI';
import { IStore } from '~/src/dash/reducers/store';
import {
  getColorTheme,
  getMacrosWiki,
  getPbsAPAC,
  getPbsEU,
  getPbsUS,
  getResellerTitle,
  getTechnicalDocumentationWiki,
} from '~/src/dash/resellers/utils/importResellerConfig';
import { isPBSDomain } from '~/src/dash/resellers/utils/utils';
import {
  extractRouteParams,
  navigate,
  RouteInventoryRouteEdit,
  RouteInventoryRouteList,
} from '~/src/dash/router/routes';
// views
import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import {
  IBaseState,
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { ChipCompleted } from '~/src/dash/utils/campaign-status';
import {
  genCountriesMenuListFromSelectedAndDisable,
  generateCountriesMenuList,
  generateCountryGroupMenuList,
  generateCountryMenuListFromIsos,
  genTargetingCountryGroupListFromSelectedAndDisable,
} from '~/src/dash/utils/countries';
import { formatTime } from '~/src/dash/utils/date';
// utils
import { decorate } from '~/src/dash/utils/decorator';
import {
  getDeviceEnvAsItemsAndDisable,
  getDeviceEnvironmentAsItems,
  getDeviceEnvironmentSubTypes,
  getDeviceEnvironmentSubTypesAsItems,
  getDeviceEnvironmentTextFromKey,
  getDeviceEnvSubTypesAsItemsAndDisable,
} from '~/src/dash/utils/device-environments';
import {
  deviceORTBTypes,
  genDeviceTypeMenuListWithSelectedAndDisable,
  getDeviceTypesTextFromKey,
} from '~/src/dash/utils/devices';
import { parseInventoryRouteEndpointURL } from '~/src/dash/utils/endpoint-url';
import { EndpointBuilderService } from '~/src/dash/utils/endpointBuilderService';
import { livestreamOptions } from '~/src/dash/utils/livestream-options';
import { smallRadius } from '~/src/dash/utils/material-dashboard-react';
import { filterSitesByActive } from '~/src/dash/utils/models';
import { noopVoid } from '~/src/dash/utils/noop';
import { obfuscateInventoryRouteName, obfuscateSiteName } from '~/src/dash/utils/obfuscate';
import {
  exportLocalTargetingToJSON,
  importLocalTargetingParamFromJSON,
} from '~/src/dash/utils/params';
import { IPermissionCheck, IS_AUTHORIZED } from '~/src/dash/utils/permission_service';
import { APAC, EUROPE, Regions, USA } from '~/src/dash/utils/regions';
import { checkUserInfoMasked, hasRole, hasRoleSuperUser, ROLE_SUPER } from '~/src/dash/utils/roles';
import { routeName } from '~/src/dash/utils/routes';
import { isEndpointBuilderDisabled } from '~/src/dash/utils/ui';
import {
  hasErrors,
  IErrors,
  regionValidationSetting,
  validatorFactory,
} from '~/src/dash/utils/validator';
import { ccpaOptions, coppaOptions, latOptions } from '~/src/dash/views/bidder-settings-form-view';
import { ButtonView } from '~/src/dash/views/button-view';
import { H3, RowButton } from '~/src/dash/views/component-view';
import { SnackbarView } from '~/src/dash/views/snackbar-view';
import { highlight, languages } from '~/src/prismjs';

// NOTE: For settings views, it is preferred to follow this model where there is a child view
// that is responsible for the majority of the react code and several various parent views
// connected to various routes, in this case, route-settings-clone-view, route-settings-existing-view,
// and route-settings-new-view, which pass on the current Route as props to this view.
// The parent view can pass on a blank resource, a clean clone or the resource from the api.

// The resource is then placed directly into state. You can note that within state, fields that
// belong to the resource (and thus are updated via API) should be capitalized, and the other items
// in state (like loading, snackbarError, pageNumber, etc) should be lower case.  The state can then be
// destructured into the resouce when creating or updating since we send back the whole object
// to the API, making it easier to update APIs when adding new fields.

// NOTE: Please add comments to IProps and IState to explain what certain variables do, especially if it
// may be unclear.  Try to keep them grouped if they may be related. Lastly, try to keep comments to IProps
// and IState rather than in the state declaration to keep it clean.

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {
  currentRoute: IInventoryRoute;
  readOnly: boolean;
  disableAppBar: boolean;
  publisherCountryGroups: ICountryGroup[];
  sites: ISmallSite[];
  inventoryRoutesForPublisher: IInventoryRoute[];
  // route setting params
  ID: number;
  Name: string;
  RouteDestinationType: DestinationType;
  // index of channel split shown
  index: number;
}

const ROUTE_SOURCE_PILLS: IPillItem[] = [
  {
    text: destinationDemandSourceTypeToString(DestinationTypeSite),
  },
  {
    text: destinationDemandSourceTypeToString(DestinationTypeVastURL),
  },
  {
    text: destinationDemandSourceTypeToString(DestinationTypeRoute),
  },
];

const ROUTE_CONDITION_PILLS: IPillItem[] = [
  {
    text: inventoryRouteConditionTypeToString(RoutingConditionTargetingParams),
  },
  {
    text: inventoryRouteConditionTypeToString(RoutingConditionPercentageRequests),
  },
];

// NOTE: IState extends IInventoryRoute since we will place the route directly into state

interface IState extends IBaseState, IInventoryRoute {
  // snackbar
  snackbarMessage: string;
  snackbarError: boolean;
  snackbarWarning: boolean;
  updating: boolean; // indicates an api call to update is in progress
  errors: IErrors;
  sites: ISmallSite[];
  openFallbackModal: boolean;
  startingTab: number;
  endpointBuilderService: EndpointBuilderService;
  endpointParams: IParam[];
  isBackfillEnabled: boolean;
  backfillDestinationList: IMenuList;

  openRegionSelectTable: boolean;
  openRegionCreateEditDialog: boolean;
  // is component loaded and ready to display
  loaded: boolean;
  createEditRegionName: string;
  createEditRegionList: IMenuList;
  createEditRegionID: string;
  updatingCountryGroup: boolean;
  publisherCountryGroups: ICountryGroup[];

  // used to know if we display the live logs popup
  openLogsViewForRoute: boolean;
  liveLogsTabIndexForRoute: number;
  inventoryRouteRequestLiveLogs: IInventoryRouteRequestData[];
  inventoryRouteResponseLiveLogs: IInventoryRouteResponseData[];
  openLogsViewForDestination: boolean;
  liveLogsTabIndexForDestination: number;
  destinationRequestLiveLogs: IDestinationRequestData[][];
  destinationResponseLiveLogs: IDestinationResponseData[][];
  commonRegionGroups: ICountryGroup[] | undefined;
  refreshingLiveLogs: boolean;
  refreshingLiveLogsTimestamp: string;
}

const defaultZeroFields = ['TargetingCoppa', 'TargetingCCPA', 'TargetingLimitedAdTracking'];

export const RouteSettingsView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    // NOTE: Use styles when the CSS is used more than once
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 6,
        paddingLeft: theme.spacing.unit * 6 + 'px !important',
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
      },
      smPaper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
      },
      insideAccordionText: {
        fontSize: 14,
        fontWeight: 400,
        color: '$434343',
      },
      insideAccordionTextRed: {
        fontSize: 14,
        fontWeight: 400,
        color: 'red',
      },
      typographyFont: {
        fontSize: 16,
        fontWeight: 400,
        color: '$434343',
      },
      typographyFontRed: {
        fontSize: 16,
        fontWeight: 400,
        color: 'red',
      },
      typographyFontBold: {
        fontSize: 16,
        fontWeight: 500,
        color: '$434343',
      },
      typographyFontBoldRed: {
        fontSize: 16,
        fontWeight: 500,
        color: 'red',
      },
      typographyFontBoldBig: {
        fontSize: 18,
        fontWeight: 500,
        color: '$434343',
      },
      typographyFontBoldBigRed: {
        fontSize: 18,
        fontWeight: 500,
        color: 'red',
      },
      routingConditionBoxSelected: {
        cursor: 'pointer',
        backgroundColor: '#a3a6e3',
        borderRadius: 4,
        width: 140,
        textAlign: 'center',
        marginLeft: 8,
        marginRight: 8,
        boxShadow: '0px 1px 2px #CBCBCB',
        fontSize: 14,
        fontWeight: 500,
      },
      routingConditionBox: {
        cursor: 'pointer',
        backgroundColor: '#ffffff',
        borderRadius: 4,
        width: 140,
        textAlign: 'center',
        marginLeft: 8,
        marginRight: 8,
        boxShadow: '0px 1px 2px #CBCBCB',
        fontSize: 14,
        fontWeight: 400,
      },
      requestPercentageGrid: {
        marginTop: 6,
        marginBottom: 10,
      },
      addTypography: {
        fontSize: 16,
        fontWeight: 500,
        color: '#5865E8',
        marginLeft: 5,
        paddingBottom: 15,
        cursor: 'pointer',
      },
      maxWidthGrid: {
        maxWidth: 1000,
      },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = {
      ...this.props.currentRoute,
      // snackbar
      snackbarMessage: '',
      snackbarError: false,
      snackbarWarning: false,
      updating: false,
      errors: {} as IErrors,
      sites: [] as ISmallSite[],
      openFallbackModal: false,
      startingTab: 0,
      endpointBuilderService: getEndpointBuilderServiceRoute((): string =>
        this.props.currentRoute.ID.toString(),
      ),
      endpointParams: [] as IParam[],
      // set this to enabled if any destination has backfill enabled
      isBackfillEnabled: !!this.props.currentRoute.Destinations.find(
        (dest: IDestination) => dest.BackfillEnabled === EBool.EBool_TRUE,
      ),
      backfillDestinationList: {} as IMenuList,
      openRegionSelectTable: false,
      publisherCountryGroups: this.props.publisherCountryGroups as ICountryGroup[],
      createEditRegionID: '',
      createEditRegionList: generateCountriesMenuList(),
      createEditRegionName: '',
      openRegionCreateEditDialog: false,
      loaded: false, // check if used
      updatingCountryGroup: false,
      openLogsViewForRoute: false,
      liveLogsTabIndexForRoute: 0,
      inventoryRouteRequestLiveLogs: [] as IInventoryRouteRequestData[],
      inventoryRouteResponseLiveLogs: [] as IInventoryRouteResponseData[],
      openLogsViewForDestination: false,
      liveLogsTabIndexForDestination: 0,
      destinationRequestLiveLogs: [] as IDestinationRequestData[][],
      destinationResponseLiveLogs: [] as IDestinationResponseData[][],
      commonRegionGroups: [] as ICountryGroup[],
      refreshingLiveLogs: false,
      refreshingLiveLogsTimestamp: '',
    };

    // NOTE: For the lifecycle methods, if possible, try to breakout the initialization steps into helper functions

    // NOTE: We should try to build helper functions for componentDidMount, to keep the process clean
    // and readable, especially when we add more steps

    componentWillMount() {
      // define endpoint-builder refresh handler - called to refresh component when changes are done within the service
      this.state.endpointBuilderService.setServiceRefreshHandler(() => {
        this.setState({ endpointBuilderService: this.state.endpointBuilderService });
      });
      // define endpoint-builder endpoint change handler - called when endpoint value changes
      this.state.endpointBuilderService.setEndpointChangeHandler((newEndpoint: string) => {
        newEndpoint = this.handleCustomParams(newEndpoint); // replace param values by user-defined ones
        this.setState({
          EndpointURL: newEndpoint,
          EndpointURLParams: JSON.stringify(parseInventoryRouteEndpointURL(newEndpoint)),
        });
      });
    }

    componentDidMount() {
      this.getSites();
      this.generateEndpoint();
      this.generateFallbackDestinationList();
      this.getLiveLogs();
      this.getCommonRegionGroupsByIDs();
    }

    componentDidUpdate(prevProps: Readonly<IProps>) {
      if (!isEqual(prevProps.currentRoute, this.props.currentRoute)) {
        this.setState({
          ...this.props.currentRoute,
          endpointBuilderService: getEndpointBuilderServiceRoute((): string =>
            this.props.currentRoute.ID.toString(),
          ),
          isBackfillEnabled: this.props.currentRoute.Destinations.some(
            (dest: IDestination) => dest.BackfillEnabled === EBool.EBool_TRUE,
          ),
        });
      }
    }

    generateInventoryRouteDestinationTargetList(destinationType: DestinationType): IMenuList {
      const newInventoryRouteDestinationTargetList = {} as IMenuList;
      let activeDestinationTargets: any[] = [];
      switch (destinationType) {
        case DestinationTypeSite:
          activeDestinationTargets = filterSitesByActive(this.state.sites);
          for (const target of activeDestinationTargets) {
            newInventoryRouteDestinationTargetList[target.ID] = {
              title: obfuscateSiteName(
                target,
                this.props.user.user.Username,
                `[${target.ID}] ${target.Name}`,
              ),
              selected: false,
              ID: target.ID.toString(),
              uuid: target.UUID,
            };
          }
          break;
        case DestinationTypeRoute:
          activeDestinationTargets = filterInventoryRoutesByActive(
            this.props.inventoryRoutesForPublisher,
          );
          for (const target of activeDestinationTargets) {
            newInventoryRouteDestinationTargetList[target.ID] = {
              title: obfuscateInventoryRouteName(
                target,
                this.props.user.user.Username,
                `[${target.ID}] ${target.Name}`,
              ),
              selected: false,
              ID: target.ID.toString(),
            };
          }
          break;
      }

      return newInventoryRouteDestinationTargetList;
    }

    getSites = async () => {
      const [smallSites, err] = await getSmallSites(this.props.session.publisher.ID, 'bid_floor');
      if (err) {
        this.setState({
          snackbarError: true,
          snackbarMessage: 'Error loading sites',
        });
        return;
      }
      const sites: ISmallSite[] = smallSites || [];
      this.setState({
        sites,
      });
    };

    generateEndpoint() {
      let endpoint;
      if (this.state.Region === USA) {
        endpoint = getPbsUS() + '/v1/inventory_route';
      } else if (this.state.Region === EUROPE) {
        endpoint = getPbsEU() + '/v1/inventory_route';
      } else if (this.state.Region === APAC) {
        endpoint = getPbsAPAC() + '/v1/inventory_route';
      }

      if (endpoint) {
        if (this.state.EndpointURLParams !== '') {
          // params are already defined, reconstruct endpoint
          endpoint += '?';
          const params = JSON.parse(this.state.EndpointURLParams);
          endpoint += Object.keys(params)
            .map((name: string) => name + '=' + params[name])
            .join('&');
        }
        // set the initial endpoint for this existing endpoint builder
        this.handleCustomParams(endpoint); // save custom param value from existing endpoint

        // set current endpoint in endpoint builder
        this.state.endpointBuilderService.setEndpoint(endpoint);
        this.state.endpointBuilderService.refresh();
      }
    }

    updateCountryGroupsByPublisherID = () => {
      const { session } = this.props;
      const { Destinations } = this.state;
      getCountryGroupsByPublisherID(session.publisher.ID).then(
        (publisherCountryGroups: ICountryGroup[]) => {
          const destinationsClone = cloneDeep(Destinations);
          for (let i = 0; i < destinationsClone.length; i++) {
            const destination = destinationsClone[i];
            destination.targetingCountryGroupList =
              genTargetingCountryGroupListFromSelectedAndDisable(
                publisherCountryGroups,
                destination.TargetingCountryGroupIDs,
              );
          }
          this.setState({
            publisherCountryGroups,
            Destinations: destinationsClone,
          });
        },
      );
    };

    getCommonRegionGroupsByIDs = () => {
      getCountryGroupsByIDs(commonRegionGroupsIDs, this.props.session.publisher.ID)
        .then((regionGroups) => {
          this.setState({ commonRegionGroups: regionGroups[0] });
        })
        .catch(() => {
          this.setState({
            commonRegionGroups: [],
            snackbarError: true,
            snackbarMessage: 'Error loading common country groups',
          });
        });
    };

    deleteCountryGroupFromDestinations = (countryGroupID: string): IDestination[] => {
      const { Destinations } = this.state;
      const destinationsClone = cloneDeep(Destinations);
      for (let i = 0; i < destinationsClone.length; i++) {
        const destination = destinationsClone[i];
        const destinationTCGList = destination.targetingCountryGroupList;
        delete destinationTCGList[countryGroupID];
      }
      return destinationsClone;
    };

    // -------- ENDPOINT BUILDER HELPER FUNCTIONS -------- //

    // update param value with user defined ones (via the 'customize params value' pop-up)
    handleCustomParams = (endpoint: string): string => {
      let oldParams = [...this.state.endpointParams];
      const newParams = this.getParamsFromURL(endpoint);
      // create param name sets for quick lookup
      const oldParamSet = new Set(oldParams.map((oldParam) => oldParam.name));
      const newParamSet = new Set(newParams.map((newParam) => newParam.name));

      // create new params (params not previously set in IParams array)
      for (const newParam of newParams) {
        // if the new param does not already exist in the old params, add it
        if (!oldParamSet.has(newParam.name)) {
          oldParams.push(newParam);
          continue;
        }

        // otherwise, the param already exists in the old params & it should be updated
        // const foundOldParam = oldParams.find((oldParam) => oldParam.name === newParam.name) || { value: '' };
        // foundOldParam.value = newParam.value;
      }

      // delete the params that are not selected anymore + delete from newParamSet to remove duplicates
      oldParams = oldParams.filter((oldParam) => {
        if (newParamSet.has(oldParam.name)) {
          newParamSet.delete(oldParam.name);
          return true;
        }
        return false;
      });

      // save new params in state
      const newEndpointURL = this.URLWithCustomParams(oldParams);
      this.setState({
        EndpointURL: newEndpointURL,
        endpointParams: oldParams,
      });

      // recreate URL with user-defined values instead of default values
      return newEndpointURL;
    };

    handleSetUpdatingCountryGroup = (updatingCountryGroup: boolean) => {
      this.setState({ updatingCountryGroup });
    };

    handleOpenRegionSelectDialog = (countryGroupID: string) => {
      const { publisherCountryGroups } = this.state;
      const foundCountryGroup = publisherCountryGroups.find(
        (countryGroup: ICountryGroup) => countryGroup.ID.toString() === countryGroupID,
      );

      let newCreateEditRegionList = generateCountriesMenuList();
      let newCreateEditRegionName = '';
      if (foundCountryGroup) {
        newCreateEditRegionList = generateCountryMenuListFromIsos(
          foundCountryGroup.CountryIsos.split(','),
        );
        newCreateEditRegionName = foundCountryGroup.Name;
      }
      this.setState({
        createEditRegionID: countryGroupID,
        createEditRegionList: newCreateEditRegionList,
        createEditRegionName: newCreateEditRegionName,
        openRegionCreateEditDialog: true,
        openRegionSelectTable: false,
      });
    };

    // return list of key-value params from given URL
    getParamsFromURL = (url: string): IParam[] => {
      const params: IParam[] = [];
      // split URL between domain and parameters - 'google.com/test?a=1&b=2' => ['google.com/test', 'a=1&b=2']
      const urlSplit = url.split('?');
      if (urlSplit.length < 2) {
        return params; // no parameters, so nothing to do here
      }
      // split URL parameter part into parameters - 'a=1&b=2' => ['a=1', 'b=2']
      const paramSplit = urlSplit[1].split('&');
      // iterate through parameters
      for (const paramStr of paramSplit) {
        // split parameter in key + value - 'a=1' => key='a', value='1'
        const paramStrSplit = paramStr.split('=');
        if (paramStrSplit.length < 2) {
          continue; // incorrect parameter format - ignore it
        }
        const key = paramStrSplit[0];
        const value = paramStrSplit.slice(1).join('='); // if '=' is present in the value, recreate the string
        // append to params
        params.push({ name: key, value });
      }
      return params;
    };

    // transform an URL with default-params to an URL with user-custom params
    URLWithCustomParams = (params: IParam[]): string => {
      let domain = '';
      if (this.state.Region === USA) {
        domain = getPbsUS() + '/v1/inventory_route';
      } else if (this.state.Region === EUROPE) {
        domain = getPbsEU() + '/v1/inventory_route';
      } else if (this.state.Region === APAC) {
        domain = getPbsAPAC() + '/v1/inventory_route';
      }
      const separator = params.length > 0 ? '?' : ''; // parameter separation (if any)
      const paramsStr = params.map((param: IParam) => param.name + '=' + param.value).join('&'); // new parameters
      return domain + separator + paramsStr;
    };

    // -------- COMPONENT HELPER FUNCTIONS -------- //

    // NOTE: make functions for permissions (super, canEdit, masking) to reduce potential errors
    isSuper = (): boolean => {
      return hasRole(this.props.user.user, [ROLE_SUPER]);
    };

    isUserInfoMasked = (): boolean => {
      return checkUserInfoMasked(this.props.user.user);
    };

    hasWriteRights = (): IPermissionCheck => {
      return IS_AUTHORIZED(['write_inventory_route'], this.props.user.user);
    };

    // gets errors for route before it is sent to API to be created or updated and returns errors for the user to fix before saving again
    getInventoryRouteFormErrors = (): string[] => {
      const {
        Name,
        Active,
        Destinations,
        FreewheelPublisherID,
        RoutingCondition,
        isBackfillEnabled,
      } = this.state;
      let errors = [] as string[];

      if (Active === ResourceActiveUnknown) {
        errors.push('Active unknown');
      }
      if (Name === '') {
        errors.push('Enter a name');
      }
      if (Name === 'New Inventory Route') {
        errors.push('Select a custom name');
      }
      if (Destinations.length === 0) {
        errors.push('Add at least one destination');
      }
      if (FreewheelPublisherID && RoutingCondition === RoutingConditionTargetingParams) {
        let foundFallback = false;

        for (const destination of Destinations) {
          const nonEmptyValues = this.findDestinationNonEmptyValues(destination);
          if (nonEmptyValues.length === 0) {
            foundFallback = true;
            break;
          }
        }
        if (!foundFallback) {
          errors.push('Freewheel Inventory Route must have a fallback destination (no targeting)');
        }
      }

      if (isBackfillEnabled) {
        const backfillSelected = !!Destinations.find(
          (destination: IDestination) => destination.BackfillEnabled === EBool.EBool_TRUE,
        );

        if (!backfillSelected) {
          errors.push('Backfill is enabled but no destination was selected');
        }
      }

      // check that all routes have a share of requests and the total equals 100
      if (RoutingCondition === RoutingConditionPercentageRequests) {
        let total = 0;
        let hasDestinationLessThan0 = false;
        let hasDestinationGreaterThan100 = false;

        for (const destination of Destinations) {
          if (destination.ShareOfRequests <= 0) {
            hasDestinationLessThan0 = true;
            if (!hasDestinationLessThan0) {
              errors.push('Destinations must have a % of request > 0');
            }
          }

          if (destination.ShareOfRequests >= 100) {
            hasDestinationGreaterThan100 = true;
            if (!hasDestinationGreaterThan100) {
              errors.push('Destinations must have a % of request <= 100');
            }
          }

          total += destination.ShareOfRequests;
        }

        if (total !== 100) {
          errors.push('The sum of all percentage of requests must equal 100');
        }
      } else {
        // check only 1 parameter is active for all destinations
        const activeParams = this.findActiveTargetingParams();
        if (activeParams.length > 1 && !this.state.FreewheelPublisherID) {
          // freewheel inventory routes can have multiple params but must have a fallback
          errors.push(
            `Only 1 targeting parameter may be active. ${activeParams.join(
              ', ',
            )} are currently active`,
          );
        }
        if (activeParams.length === 0 && Destinations.length > 1) {
          errors.push(
            `At least 1 targeting parameter must be active for all non-fallback destinations`,
          );
        }
        // check that all destinations have at least one param entered
        const allNonEmptyValues = [] as string[];
        const allNonEmptyValuesNames = [] as string[];

        for (const destination of Destinations) {
          const nonEmptyValues = this.findDestinationNonEmptyValues(destination);
          allNonEmptyValues.push(nonEmptyValues.join(','));
          if (destination.Name === '') {
            errors.push(
              `${
                destination.ID === 0 ? 'New Destination' : `Destination ID: ${destination.ID}`
              } requires a name`,
            );
          } else {
            allNonEmptyValuesNames.push(destination.Name);
          }
          if (destination.DestinationType === DestinationTypeSite && !destination.SiteID) {
            errors.push(`Destination ${destination.Name} requires a channel selection`);
          }
          if (destination.DestinationType === DestinationTypeVastURL && !destination.VastURL) {
            errors.push(`Destination ${destination.Name} requires a Vast URL`);
          }
        }

        // check that no targeting params are identical (must split since they can be comma separated)
        if (activeParams.length === 1) {
          const paramsMap = {} as { [key: string]: boolean };
          const nonStringParamsVals = [
            'TargetingCoppa',
            'TargetingLivestream',
            'TargetingLimitedAdTracking',
            'TargetingCCPA',
          ];
          const activeParam = activeParams[0];

          if (activeParam === 'LocalTargeting') {
            errors = [
              ...errors,
              ...validateLocalTargeting(
                Destinations.flatMap((destination: IDestination) => {
                  return destination.localTargetingParameters;
                }),
              ),
            ];
          }

          for (const destination of Destinations) {
            if (activeParam === 'LocalTargeting') {
              continue;
            }
            // @ts-ignore
            let commaSepParamValue = destination[activeParam];
            if (nonStringParamsVals.includes(activeParam)) {
              // these are numbers and must be converted
              commaSepParamValue = commaSepParamValue.toString();
            }
            if (commaSepParamValue.length > 0) {
              for (const paramValue of commaSepParamValue.split(',')) {
                let inclusionFieldName = `${activeParam}IsAllowed` as DestinationInclusionFieldKeys;
                if (activeParam.includes('Custom') || activeParam === 'TargetingFWSectionIDs') {
                  inclusionFieldName = `${activeParam}Inclusion` as DestinationInclusionFieldKeys;
                }
                // some destinations don't have Inclusion Field
                let isAllowed = true;
                if (destination[inclusionFieldName] !== undefined) {
                  isAllowed = destination[inclusionFieldName] === EAllowStatus.ALLOW;
                }
                if (paramsMap[paramValue.trim()] && isAllowed) {
                  if (activeParam === 'TargetingDevices') {
                    errors.push(
                      `Duplicate value for Device Env: ${getDeviceEnvironmentTextFromKey(
                        paramValue,
                      )}`,
                    );
                  } else if (activeParam === 'TargetingDeviceTypes') {
                    errors.push(
                      `Duplicate value for Device Type: ${getDeviceTypesTextFromKey(paramValue)}`,
                    );
                  } else {
                    if (defaultZeroFields.includes(activeParam)) {
                      errors.push(
                        `Duplicate value for ${activeParam.slice(9, activeParam.length)}`,
                      );
                    } else {
                      // remove "targeting" from the param name
                      errors.push(
                        `Duplicate value for ${activeParam.slice(
                          9,
                          activeParam.length,
                        )}: ${paramValue}`,
                      );
                    }
                  }
                } else {
                  if (defaultZeroFields.includes(activeParam) && paramValue === '0') {
                    continue;
                  }
                  // only add to map if Inclusion Field or dest has no Include/Exclude
                  if (isAllowed) {
                    paramsMap[paramValue.trim()] = true;
                  }
                }
              }
            }
          }
        }
      }

      for (const destination of Destinations) {
        if (
          destination.VastURL.toLowerCase().includes('[site_id]') &&
          isPBSDomain(destination.VastURL)
        ) {
          errors.push(
            `Destination [${destination.ID}] ${
              destination.Name
            }: Destinations cannot use the [SITE_ID] macro for ${getResellerTitle()} VAST URLs`,
          );
        }
        if (destination.VastURL.includes('inventory_route_id=')) {
          errors.push(
            `Destination [${destination.ID}] ${destination.Name}: Destination VAST URLs cannot target inventory routes, please use the Routes tab instead`,
          );
        }
      }

      return errors;
    };

    // returns all non empty string values for the destination
    findDestinationNonEmptyValues = (Destination: IDestination): string[] => {
      const nonEmptyValues = [] as string[];
      const skipFields = [
        // skip non targeting fields
        'ID',
        'CreatedAt',
        'UpdatedAt',
        'DeletedAt',
        'RouteID',
        'SiteID',
        'SiteUUID',
        'ShareOfRequests',
        'Name',
        'VastURL',
        'DestinationType',
        'BackfillEnabled',
        'localTargetingParameters',
        'targetingCountriesList',
        'targetingCountryGroupList',
        'CountryGroups',
        'LocalTargetingLogic',
        'CountryGroups',
        'inventoryRouteChannelList',
        'inventoryRouteRouteList',
        'ForwardingRouteID',
      ];

      // these fields always have a value and are not empty
      // they have exception cases in the if statement below
      const exceptionFields = [
        'TargetingLivestream',
        'TargetingLimitedAdTracking',
        'TargetingCoppa',
        'TargetingCCPA',
        'LocalTargeting',
      ];

      for (const [key, value] of Object.entries(Destination)) {
        if (
          skipFields.includes(key) ||
          key.indexOf('IsAllowed') > -1 ||
          key.indexOf('Inclusion') > -1
        ) {
          continue;
        } else if (key === 'TargetingLivestream' && value !== TargetingLivestreamAll) {
          nonEmptyValues.push(value);
        } else if (defaultZeroFields.includes(key) && value !== 0) {
          nonEmptyValues.push(value);
        } else if (key === 'LocalTargeting' && value !== '[]' && value !== '') {
          nonEmptyValues.push(value);
        } else if (!exceptionFields.includes(key) && value !== '') {
          nonEmptyValues.push(value);
        }
      }

      return nonEmptyValues;
    };

    // determines if there is a destination on a route with no targeting IF targeting params are selected
    // this is not required if a backfill has been selected
    routeHasFallbackOrBackfilled = (): boolean => {
      const backfillEnabled =
        this.state.Destinations.filter(
          (destination: IDestination) => destination.BackfillEnabled === EBool.EBool_TRUE,
        ).length > 0;

      if (this.state.RoutingCondition === RoutingConditionPercentageRequests || backfillEnabled) {
        return true;
      }

      let foundFallback = false;
      for (const destination of this.state.Destinations) {
        const nonEmptyValues = this.findDestinationNonEmptyValues(destination);
        if (nonEmptyValues.length === 0) {
          foundFallback = true;
          break;
        }
      }

      return foundFallback;
    };

    generateInventoryRoute = (): IInventoryRoute => {
      const route = {
        ID: this.state.ID,
        EndpointURL: this.state.EndpointURL,
        Name: this.state.Name,
        Active: this.state.Active,
        RoutingCondition: this.state.RoutingCondition,
        PublisherID: parseInt(this.props.session.publisher.ID, 10),
        PublisherUUID: this.props.session.publisher.UUID,
        Destinations: this.state.Destinations,
        Region: this.state.Region,
        EndpointURLParams: this.state.EndpointURLParams,
        Timeout: this.state.Timeout,
      } as IInventoryRoute;
      if (this.state.FreewheelPublisherID) {
        route.FreewheelPublisherID = this.state.FreewheelPublisherID;
      } else {
        route.FreewheelPublisherID = null;
      }
      return route;
    };

    generateFallbackDestinationList = () => {
      const backfillDestinationList = {} as IMenuList;

      for (let i = 0; i < this.state.Destinations.length; i++) {
        const destination = this.state.Destinations[i];
        backfillDestinationList[i.toString()] = {
          title: destination.Name,
          selected: destination.BackfillEnabled === EBool.EBool_TRUE,
          ID: i.toString(),
        };
      }

      this.setState({
        backfillDestinationList,
      });
    };

    clearBackfillEnabledFromDestinations = () => {
      const backfillDestinationList = cloneDeep(this.state.backfillDestinationList);
      const Destinations = cloneDeep(this.state.Destinations);
      for (const item of Object.values(backfillDestinationList)) {
        item.selected = false;
      }

      for (let i = 0; i < Destinations.length; i++) {
        Destinations[i].BackfillEnabled = EBool.EBool_FALSE;
      }

      this.setState({
        backfillDestinationList,
        Destinations,
        isBackfillEnabled: false,
      });
    };

    // determines if any targeting param is active for the destinations
    findActiveTargetingParams = (): string[] => {
      const activeParams = {} as { [key: string]: boolean };
      for (const destination of this.state.Destinations) {
        if (destination.TargetingAppBundleID !== '') {
          activeParams.TargetingAppBundleID = true;
        }
        if (destination.TargetingContentChannel !== '') {
          activeParams.TargetingContentChannel = true;
        }
        if (destination.TargetingContentDistributor !== '') {
          activeParams.TargetingContentDistributor = true;
        }
        if (destination.TargetingContentGenre !== '') {
          activeParams.TargetingContentGenre = true;
        }
        if (destination.TargetingContentID !== '') {
          activeParams.TargetingContentID = true;
        }
        if (destination.TargetingContentNetwork !== '') {
          activeParams.TargetingContentNetwork = true;
        }
        if (destination.TargetingContentProducer !== '') {
          activeParams.TargetingContentProducer = true;
        }
        if (destination.TargetingContentRating !== '') {
          activeParams.TargetingContentRating = true;
        }
        if (destination.TargetingContentSeries !== '') {
          activeParams.TargetingContentSeries = true;
        }
        if (destination.TargetingContentTitle !== '') {
          activeParams.TargetingContentTitle = true;
        }
        if (destination.TargetingDealID !== '') {
          activeParams.TargetingDealID = true;
        }
        if (destination.TargetingFWSectionIDs !== '') {
          activeParams.TargetingFWSectionIDs = true;
        }
        if (destination.TargetingDevices !== '') {
          activeParams.TargetingDevices = true;
        }
        if (destination.TargetingDeviceSubTypes !== '') {
          activeParams.TargetingDevices = true;
        }
        if (destination.TargetingDeviceTypes !== '') {
          activeParams.TargetingDeviceTypes = true;
        }
        if (destination.TargetingCustom4 !== '') {
          activeParams.TargetingCustom4 = true;
        }
        if (destination.TargetingCustom5 !== '') {
          activeParams.TargetingCustom5 = true;
        }
        if (destination.TargetingCustom6 !== '') {
          activeParams.TargetingCustom6 = true;
        }
        if (destination.TargetingCustom7 !== '') {
          activeParams.TargetingCustom7 = true;
        }
        if (destination.TargetingCustom8 !== '') {
          activeParams.TargetingCustom8 = true;
        }
        if (destination.TargetingCustom9 !== '') {
          activeParams.TargetingCustom9 = true;
        }
        if (destination.TargetingCustom10 !== '') {
          activeParams.TargetingCustom10 = true;
        }
        if (destination.TargetingCustom11 !== '') {
          activeParams.TargetingCustom11 = true;
        }
        if (destination.TargetingCustom12 !== '') {
          activeParams.TargetingCustom12 = true;
        }
        if (destination.TargetingCustom13 !== '') {
          activeParams.TargetingCustom13 = true;
        }
        if (destination.TargetingCustom14 !== '') {
          activeParams.TargetingCustom14 = true;
        }
        if (destination.TargetingCustom15 !== '') {
          activeParams.TargetingCustom15 = true;
        }
        if (destination.TargetingCustom16 !== '') {
          activeParams.TargetingCustom16 = true;
        }
        if (destination.TargetingCustom17 !== '') {
          activeParams.TargetingCustom17 = true;
        }
        if (destination.TargetingCustom18 !== '') {
          activeParams.TargetingCustom18 = true;
        }
        if (destination.TargetingWSeat !== '') {
          activeParams.TargetingWSeat = true;
        }
        if (destination.TargetingLivestream !== 0) {
          activeParams.TargetingLivestream = true;
        }
        if (destination.localTargetingParameters.length > 0) {
          activeParams.LocalTargeting = true;
        }
        if (destination.TargetingCountryGroupIDs !== '') {
          activeParams.TargetingCountryGroupIDs = true;
        }
        if (destination.TargetingDeviceCountry !== '') {
          activeParams.TargetingDeviceCountry = true;
        }
        if (destination.TargetingCoppa !== TargetingCoppaAll) {
          activeParams.TargetingCoppa = true;
        }
        if (destination.TargetingCCPA !== TargetingCCPAAll) {
          activeParams.TargetingCCPA = true;
        }
        if (destination.TargetingLimitedAdTracking !== TargetBoolTypeAll) {
          activeParams.TargetingLimitedAdTracking = true;
        }
      }

      return Object.keys(activeParams);
    };

    clearDestinationTargetingAndShare = (destination: IDestination): IDestination => {
      destination.ShareOfRequests = 0;
      destination.TargetingAppBundleID = '';
      destination.TargetingAppBundleIDIsAllowed = EAllowStatus.ALLOW;
      destination.TargetingContentChannel = '';
      destination.TargetingContentChannelIsAllowed = EAllowStatus.ALLOW;
      destination.TargetingContentDistributor = '';
      destination.TargetingContentDistributorIsAllowed = EAllowStatus.ALLOW;
      destination.TargetingContentGenre = '';
      destination.TargetingContentGenreIsAllowed = EAllowStatus.ALLOW;
      destination.TargetingContentID = '';
      destination.TargetingContentIDIsAllowed = EAllowStatus.ALLOW;
      destination.TargetingContentNetwork = '';
      destination.TargetingContentNetworkIsAllowed = EAllowStatus.ALLOW;
      destination.TargetingContentProducer = '';
      destination.TargetingContentProducerIsAllowed = EAllowStatus.ALLOW;
      destination.TargetingContentRating = '';
      destination.TargetingContentRatingIsAllowed = EAllowStatus.ALLOW;
      destination.TargetingContentSeries = '';
      destination.TargetingContentSeriesIsAllowed = EAllowStatus.ALLOW;
      destination.TargetingContentTitle = '';
      destination.TargetingContentTitleIsAllowed = EAllowStatus.ALLOW;
      destination.TargetingDealID = '';
      destination.TargetingDeviceTypes = '';
      destination.TargetingDeviceTypesIsAllowed = EAllowStatus.ALLOW;
      destination.TargetingDevices = '';
      destination.TargetingDevicesIsAllowed = EAllowStatus.ALLOW;
      destination.TargetingCustom4 = '';
      destination.TargetingCustom4Inclusion = EAllowStatus.ALLOW;
      destination.TargetingCustom5 = '';
      destination.TargetingCustom5Inclusion = EAllowStatus.ALLOW;
      destination.TargetingCustom6 = '';
      destination.TargetingCustom6Inclusion = EAllowStatus.ALLOW;
      destination.TargetingCustom7 = '';
      destination.TargetingCustom7Inclusion = EAllowStatus.ALLOW;
      destination.TargetingCustom8 = '';
      destination.TargetingCustom8Inclusion = EAllowStatus.ALLOW;
      destination.TargetingCustom9 = '';
      destination.TargetingCustom9Inclusion = EAllowStatus.ALLOW;
      destination.TargetingCustom10 = '';
      destination.TargetingCustom10Inclusion = EAllowStatus.ALLOW;
      destination.TargetingCustom11 = '';
      destination.TargetingCustom11Inclusion = EAllowStatus.ALLOW;
      destination.TargetingCustom12 = '';
      destination.TargetingCustom12Inclusion = EAllowStatus.ALLOW;
      destination.TargetingCustom13 = '';
      destination.TargetingCustom13Inclusion = EAllowStatus.ALLOW;
      destination.TargetingCustom14 = '';
      destination.TargetingCustom14Inclusion = EAllowStatus.ALLOW;
      destination.TargetingCustom15 = '';
      destination.TargetingCustom15Inclusion = EAllowStatus.ALLOW;
      destination.TargetingCustom16 = '';
      destination.TargetingCustom16Inclusion = EAllowStatus.ALLOW;
      destination.TargetingCustom17 = '';
      destination.TargetingCustom17Inclusion = EAllowStatus.ALLOW;
      destination.TargetingCustom18 = '';
      destination.TargetingCustom18Inclusion = EAllowStatus.ALLOW;
      destination.CountryGroups = [] as ICountryGroup[];
      destination.TargetingCountryGroupIDs = '';
      destination.TargetingCountryGroupIDsIsAllowed = EAllowStatus.ALLOW;
      destination.LocalTargeting = '';
      destination.LocalTargetingIsAllowed = EAllowStatus.ALLOW;
      destination.localTargetingParameters = [] as ILocalTargetingParameter[];
      destination.TargetingDeviceCountry = '';
      destination.TargetingDeviceCountryIsAllowed = EAllowStatus.ALLOW;
      destination.targetingCountriesList = generateCountriesMenuList();
      destination.targetingCountryGroupList = {} as IMenuList;
      destination.TargetingLivestream = TargetingLivestreamAll;
      destination.TargetingWSeat = '';
      destination.TargetingCoppa = TargetingCoppaAll;
      destination.TargetingCCPA = TargetingCCPAAll;
      destination.TargetingLimitedAdTracking = TargetBoolTypeAll;
      return destination;
    };

    // -------- HANDLER FUNCTIONS -------- //
    // NOTE: functions passed into a child component which update state in the parent
    // should be called handleFunc.  They are used to not directly modify the props/state
    // and make sure the parent component is properly re-rendered

    // Top bar name change
    handleNameChange = (name: string): void => {
      this.setState({
        Name: name,
      });
    };

    // Top bar close
    handleClose = (): void => {
      navigate(
        RouteInventoryRouteList,
        extractRouteParams({
          session: this.props.session,
          user: this.props.user,
        }),
      );
    };

    validateInventoryRoute = (): boolean => {
      const errors = this.getInventoryRouteFormErrors();

      if (errors.length > 0) {
        this.setState({
          snackbarError: true,
          snackbarMessage: errors.join('\n'),
          snackbarWarning: false,
          openFallbackModal: false,
        });
        return false;
      }

      if (!this.routeHasFallbackOrBackfilled() && !this.state.openFallbackModal) {
        this.setState({
          openFallbackModal: true,
        });
        return false;
      }

      return true;
    };

    // Top bar save when switching active
    handleChangeActive = () => {
      if (!this.validateInventoryRoute()) {
        return;
      }

      this.setState(
        {
          Active:
            this.state.Active === ResourceActiveEnabled
              ? ResourceActiveDisabled
              : ResourceActiveEnabled,
        },
        this.handleSave,
      );
    };

    // Top bar save
    handleSave = (): void => {
      if (this.props.readOnly) {
        return;
      }

      if (!this.validateInventoryRoute()) {
        return;
      }

      const updatedDestinations = this.exportLocalTargetingParamToJSON();

      this.setState(
        {
          Destinations: updatedDestinations,
          updating: true,
        },
        () => {
          const generatedRoute = this.generateInventoryRoute();
          if (generatedRoute.ID === 0) {
            createInventoryRoute(generatedRoute, this.props.session.publisher.ID)
              .then((resp) => {
                const route = transformInventoryRoute(resp.parsedBody);
                this.setState(
                  {
                    snackbarMessage: 'Successfully saved route.',
                    snackbarError: false,
                    snackbarWarning: false,
                    updating: false,
                    openFallbackModal: false,
                  },
                  () => {
                    setTimeout(() => {
                      navigate(RouteInventoryRouteEdit, extractRouteParams(this.props), {
                        p: this.props.session.publisher.ID,
                        inventoryrouteid: route.ID.toString(),
                      });
                    }, 500);
                  },
                );
              })
              .catch((err) => {
                this.setState({
                  snackbarMessage: `Failed to save route: ${err}`,
                  snackbarError: true,
                  snackbarWarning: false,
                  updating: false,
                  openFallbackModal: false,
                });
              });
          } else {
            updateInventoryRoute(generatedRoute, this.props.session.publisher.ID)
              .then((resp) => {
                const { publisherCountryGroups } = this.state;
                const route = transformInventoryRoute(resp.parsedBody);
                const Destinations = route.Destinations;
                for (let i = 0; i < Destinations.length; i++) {
                  Destinations[i]['targetingCountriesList' as DestinationMenuLists] =
                    genCountriesMenuListFromSelectedAndDisable(
                      Destinations[i].TargetingDeviceCountry,
                    ) as IMenuList;
                  Destinations[i]['targetingCountryGroupList' as DestinationMenuLists] =
                    genTargetingCountryGroupListFromSelectedAndDisable(
                      publisherCountryGroups,
                      Destinations[i].TargetingCountryGroupIDs,
                    ) as IMenuList;
                  Destinations[i]['localTargetingParameters' as DestinationLocalTargetingParams] =
                    importLocalTargetingParamFromJSON(
                      Destinations[i].LocalTargeting,
                    ) as ILocalTargetingParameter[];
                  if (Destinations[i].DestinationType === DestinationTypeSite) {
                    Destinations[i]['inventoryRouteChannelList' as DestinationMenuLists] =
                      genInvenRouteChannelListFromSelected(
                        Destinations[i].SiteID,
                        this.state.sites,
                        this.props.user.user.Username,
                      ) as IMenuList;
                    Destinations[i]['inventoryRouteRouteList' as DestinationMenuLists] =
                      {} as IMenuList;
                  } else if (Destinations[i].DestinationType === DestinationTypeRoute) {
                    Destinations[i]['inventoryRouteRouteList' as DestinationMenuLists] =
                      genInvenRouteRouteListFromSelected(
                        Destinations[i].ForwardingRouteID,
                        this.props.inventoryRoutesForPublisher,
                        this.props.user.user.Username,
                      ) as IMenuList;
                    Destinations[i]['inventoryRouteChannelList' as DestinationMenuLists] =
                      {} as IMenuList;
                  } else {
                    Destinations[i]['inventoryRouteChannelList' as DestinationMenuLists] =
                      {} as IMenuList;
                    Destinations[i]['inventoryRouteRouteList' as DestinationMenuLists] =
                      {} as IMenuList;
                  }
                }
                this.setState({
                  Destinations: route.Destinations,
                  snackbarMessage: 'Successfully updated route.',
                  snackbarError: false,
                  snackbarWarning: false,
                  updating: false,
                  openFallbackModal: false,
                });
              })
              .catch((err) => {
                this.setState({
                  snackbarMessage: `Failed to update route: ${err}`,
                  snackbarError: true,
                  snackbarWarning: false,
                  updating: false,
                  openFallbackModal: false,
                });
              });
          }
        },
      );
    };

    // Top bar delete
    handleDelete = (): void => {
      if (this.props.readOnly) {
        return;
      }
      this.setState(
        {
          updating: true,
        },
        () => {
          if (this.state.ID === 0) {
            this.handleClose();
          } else {
            deleteInventoryRoute(this.state.ID.toString(), this.props.session.publisher.ID)
              .then(() => {
                this.handleClose();
              })
              .catch((err: any) => {
                console.error(err);
                this.setState({
                  updating: false,
                  snackbarMessage: 'Error while deleting route.',
                  snackbarError: true,
                  snackbarWarning: false,
                });
              });
          }
        },
      );
    };

    handleChange = ({ target }: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      if (this.props.readOnly) {
        return;
      }
      if (target.name === 'isBackfillEnabled') {
        // if we are switching backfill enabled off, we need to disable backfill in all destinations
        if (this.state.isBackfillEnabled) {
          this.clearBackfillEnabledFromDestinations();
        } else {
          this.setState({
            isBackfillEnabled: !this.state.isBackfillEnabled,
          });
        }
        return;
      } else if (target.name === 'LocalTargetingIsAllowed') {
        const Destinations = cloneDeep(this.state.Destinations);
        const targetIndex = parseInt(target.value, 10);
        for (let i = 0; i < Destinations.length; i++) {
          if (i === targetIndex) {
            Destinations[i].LocalTargetingIsAllowed =
              Destinations[i].LocalTargetingIsAllowed === EAllowStatus.ALLOW
                ? EAllowStatus.DENY
                : EAllowStatus.ALLOW;
          } else {
            // only 1 destination may be deny at a time
            Destinations[i].LocalTargetingIsAllowed = EAllowStatus.ALLOW;
          }
        }

        this.setState({
          Destinations,
        });
        return;
      } else if (target.name === 'LocalTargetingLogic') {
        const Destinations = cloneDeep(this.state.Destinations);
        const targetIndex = parseInt(target.value, 10);
        for (let i = 0; i < Destinations.length; i++) {
          if (i === targetIndex) {
            Destinations[i].LocalTargetingLogic =
              Destinations[i].LocalTargetingLogic === TargetingLogicOR
                ? TargetingLogicAND
                : TargetingLogicOR;
          }
        }

        this.setState({
          Destinations,
        });
        return;
      } else if (target.name === 'FreewheelPublisherID' || target.name === 'Timeout') {
        const value = parseInt(target.value, 10);
        if (target.value === '') {
          // empty string should set the field blank
          this.setState({
            [target.name]: null,
          });
          return;
        } else if (Number.isNaN(value)) {
          // not a number should make no changes to the field
          return;
        }
        if (target.name === 'Timeout' && value > 5000) {
          this.setState({
            snackbarError: true,
            snackbarMessage: 'Timeout must less than 5000',
          });
          return;
        }
        this.setState({
          [target.name]: Number.isNaN(value) ? null : value,
        });
        return;
      }
      this.setState({
        [target.name]: target.value,
      });
    };

    // remove destination from list
    handleDeleteDestination = (destIndex: number | undefined) => {
      if (this.props.readOnly) {
        return;
      }
      const Destinations = this.state.Destinations;
      let snackbarMessage = '';
      // @ts-ignore
      const newDestinations = Destinations.filter((dest, idx) => {
        if (destIndex === idx) {
          snackbarMessage = `Removed Destination: ${dest.Name}. \n To save the destination deletion, save the inventory route.`;
        } else {
          return dest;
        }
      });
      this.setState({
        Destinations: newDestinations,
        snackbarMessage,
        snackbarError: false,
        snackbarWarning: true,
      });
    };

    handleChangeDestinationType = (index: number, value: string) => {
      if (this.props.readOnly) {
        return;
      }
      const Destinations = cloneDeep(this.state.Destinations);
      let newDestinationType;
      switch (value) {
        case 'Channel':
          newDestinationType = DestinationTypeSite;
          break;
        case 'Route':
          newDestinationType = DestinationTypeRoute;
          break;
        default:
          newDestinationType = DestinationTypeVastURL;
          break;
      }
      Destinations[index].DestinationType = newDestinationType;
      if (Destinations[index].DestinationType === DestinationTypeSite) {
        Destinations[index].VastURL = '';
        Destinations[index].ForwardingRouteID = undefined;
        Destinations[index].inventoryRouteRouteList = {} as IMenuList;
        Destinations[index].inventoryRouteChannelList =
          this.generateInventoryRouteDestinationTargetList(DestinationTypeSite);
      } else if (Destinations[index].DestinationType === DestinationTypeRoute) {
        Destinations[index].VastURL = '';
        Destinations[index].SiteID = undefined;
        Destinations[index].inventoryRouteChannelList = {} as IMenuList;
        Destinations[index].inventoryRouteRouteList =
          this.generateInventoryRouteDestinationTargetList(DestinationTypeRoute);
      } else {
        // else is VAST type
        Destinations[index].SiteID = undefined;
        Destinations[index].ForwardingRouteID = undefined;
        Destinations[index].inventoryRouteRouteList = {} as IMenuList;
        Destinations[index].inventoryRouteChannelList = {} as IMenuList;
      }
      this.setState({
        Destinations,
      });
    };

    handleChangeList = (name: string, list: IMenuList) => {
      this.setState(
        Object.assign({
          [name]: list,
        }),
      );
    };

    handleChangeDestinationField = (
      field: DestinationTargetFieldKeys | string,
      destIndex: number,
      value: any,
      isDeleting?: boolean,
      targetingMenuList?: IMenuList,
    ) => {
      if (this.props.readOnly) {
        return;
      }
      let Destinations = cloneDeep(this.state.Destinations);
      if (defaultZeroFields.includes(field)) {
        if (Destinations.length > destIndex) {
          Destinations[destIndex][field as DestinationTargetFieldKeys] = value;

          this.setState({
            Destinations,
          });
        }

        return;
      }

      const prevVals = Destinations[destIndex][field as DestinationTargetFieldKeys]
        .split(',')
        .filter((v: string) => v.length);
      const newVals = value.split(',').filter((v: string) => v.length);

      if (field === 'TargetingDeviceCountry') {
        if (targetingMenuList) {
          Destinations[destIndex].targetingCountriesList = targetingMenuList;
        }
      }

      if (field === 'TargetingCountryGroupIDs') {
        const countryGroups = this.state.publisherCountryGroups.filter((countryGroup) =>
          value.split(',').includes(countryGroup.ID.toString()),
        );
        Destinations[destIndex].CountryGroups = countryGroups;
        if (targetingMenuList) {
          Destinations[destIndex].targetingCountryGroupList = targetingMenuList; // values is the IMenuList Values
        }
      }

      if (Destinations.length > destIndex) {
        Destinations[destIndex][field as DestinationTargetFieldKeys] = value;
      }

      // update Exclude field if an Included field has been toggled to Exclude
      const [excludedFieldIndexToUpdate, shouldExcludedFieldUpdate, inclusionFieldName] =
        this.shouldExcludedFieldUpdate(
          field as DestinationTargetFieldKeys,
          Destinations[destIndex],
        );
      if (shouldExcludedFieldUpdate) {
        const toDeleteValues = isDeleting
          ? prevVals.filter((pV: string) => !newVals.includes(pV))
          : [];
        Destinations = this.updateExcludedDestinationTarget(
          field as DestinationTargetFieldKeys,
          inclusionFieldName,
          excludedFieldIndexToUpdate,
          Destinations,
          isDeleting,
          toDeleteValues,
        );
      }
      this.setState({
        Destinations,
      });
    };

    shouldExcludedFieldUpdate = (
      field: DestinationTargetFieldKeys,
      destination: IDestination,
    ): [number, boolean, DestinationInclusionFieldKeys] => {
      const { Destinations } = this.state;
      let inclusionFieldName = `${field}IsAllowed` as DestinationInclusionFieldKeys;
      if (field.includes('Custom') || field === 'TargetingFWSectionIDs') {
        inclusionFieldName = `${field}Inclusion` as DestinationInclusionFieldKeys;
      }
      const currDestIsAllowed = destination[inclusionFieldName] === EAllowStatus.ALLOW;
      for (let i = 0; i < Destinations.length; i++) {
        // returns the destination index that has been toggled to Exclude
        if (Destinations[i][inclusionFieldName] === EAllowStatus.DENY && currDestIsAllowed) {
          return [i, true, inclusionFieldName];
        }
      }
      return [-1, false, inclusionFieldName];
    };

    updateExcludedDestinationTarget = (
      targetFieldName: DestinationTargetFieldKeys,
      inclusionFieldName: DestinationInclusionFieldKeys,
      excludedDestIndex: number,
      Destinations: IDestination[],
      isDeleting?: boolean,
      toDeleteValues?: string[],
    ) => {
      let excludedFieldValues = Destinations[excludedDestIndex][targetFieldName].split(',');
      if (isDeleting) {
        excludedFieldValues = excludedFieldValues.filter(
          (eV) => !(toDeleteValues || []).includes(eV) && eV.length,
        );
      }
      const includeMap = new Set();
      const excludeMap = new Set(excludedFieldValues);
      for (let i = 0; i < Destinations.length; i++) {
        if (i === excludedDestIndex) {
          continue;
        }

        Destinations[i][inclusionFieldName] = EAllowStatus.ALLOW;

        const targetValues = Destinations[i][targetFieldName].split(',');
        for (let j = 0; j < targetValues.length; j++) {
          if (!includeMap.has(targetValues[j]) && !excludeMap.has(targetValues[j])) {
            includeMap.add(targetValues[j]);
          }
        }
      }

      Destinations[excludedDestIndex][targetFieldName] = [...excludedFieldValues, ...includeMap]
        .filter((v: string) => v.length)
        .join(',');

      return Destinations;
    };

    genDisabledDestinationValues = (
      targetFieldName: DestinationTargetFieldKeys,
      inclusionFieldName: DestinationInclusionFieldKeys,
    ) => {
      const { Destinations } = this.state;

      let includedVals: string[] = [];
      let excludedVals: string[] = [];
      for (let i = 0; i < Destinations.length; i++) {
        if (Destinations[i][inclusionFieldName] === EAllowStatus.ALLOW) {
          includedVals = [...includedVals, ...Destinations[i][targetFieldName].split(',')];
        } else {
          excludedVals = [...excludedVals, ...Destinations[i][targetFieldName].split(',')];
        }
      }
      const disabledVals: string[] = [];
      for (let i = 0; i < excludedVals.length; i++) {
        if (includedVals.indexOf(excludedVals[i]) !== -1) {
          disabledVals.push(excludedVals[i]);
        }
      }
      return disabledVals;
    };

    shouldDeleteValueFromExcluded = (
      prevVals: string[],
      newVals: string[],
      targetFieldName: DestinationTargetFieldKeys,
      inclusionFieldName: DestinationInclusionFieldKeys,
    ) => {
      let selectedVal = '';
      for (let i = 0; i < prevVals.length; i++) {
        if (!newVals.includes(prevVals[i])) {
          selectedVal = prevVals[i];
        }
      }
      const disabledValues = this.genDisabledDestinationValues(
        targetFieldName as DestinationTargetFieldKeys,
        inclusionFieldName as DestinationInclusionFieldKeys,
      );
      if ((disabledValues || []).includes(selectedVal)) {
        return false;
      }
      return true;
    };

    filterExcludedField = (
      currValues: string[],
      newVals: string[],
      targetFieldName: DestinationTargetFieldKeys,
      inclusionFieldName: DestinationInclusionFieldKeys,
      isAllowed: boolean,
    ) => {
      const disabledVals = this.genDisabledDestinationValues(
        targetFieldName as DestinationTargetFieldKeys,
        inclusionFieldName as DestinationInclusionFieldKeys,
      );
      // only delete chip in excluded field if it is not disabled
      if (
        !isAllowed &&
        currValues.length === newVals.length + 1 &&
        !this.shouldDeleteValueFromExcluded(
          currValues,
          newVals,
          targetFieldName,
          inclusionFieldName,
        )
      ) {
        return null;
      }
      // only delete all highlighted chips in excluded field
      if (!isAllowed && !newVals.length) {
        newVals = currValues.filter((v: string) => (disabledVals || []).includes(v));
      }
      return newVals.filter((v) => v.length).join(',');
    };

    isUniqueDestinationValue = (
      targetFieldName: DestinationTargetFieldKeys,
      value: any,
      currValues: string[],
      inclusionFieldName?: DestinationInclusionFieldKeys,
    ) => {
      const { Destinations } = this.state;
      const updatedValues = value.split(',').filter((v: string) => v.length);
      const newValue = updatedValues.filter((v: string) => !currValues.includes(v))[0];

      for (let i = 0; i < Destinations.length; i++) {
        const destinationFieldValues = Destinations[i][targetFieldName]
          .split(',')
          .filter((v: string) => v.length);
        if (
          inclusionFieldName &&
          Destinations[i][inclusionFieldName as DestinationInclusionFieldKeys] === EAllowStatus.DENY
        ) {
          continue;
        }
        if (destinationFieldValues.includes(newValue)) {
          const fieldName = targetFieldName.slice(9, targetFieldName.length);
          this.handleSnackbarError(true, `${fieldName} "${newValue}" is not unique!`);
          return false;
        }
      }

      return true;
    };

    handleChangeDestinationInclusion = (
      field: DestinationInclusionFieldKeys,
      destIndex: number,
      isAllowedNum: EAllowStatus,
    ) => {
      if (this.props.readOnly) {
        return;
      }

      let Destinations = cloneDeep(this.state.Destinations);

      const prevIsAllowedNum = Destinations[destIndex][field];
      const targetFieldName = field.slice(0, -9) as DestinationTargetFieldKeys;
      const currDisabledVals = this.genDisabledDestinationValues(targetFieldName, field);

      // if switching an exclude back to include
      if (prevIsAllowedNum === EAllowStatus.DENY && isAllowedNum === EAllowStatus.ALLOW) {
        const currDestVals = Destinations[destIndex][targetFieldName]
          .split(',')
          .filter((v: string) => v.length);
        const valsWithDisabledRemoved = currDestVals.filter(
          (v: string) => !currDisabledVals.includes(v) && v.length,
        );
        Destinations[destIndex][targetFieldName] = valsWithDisabledRemoved.join(',');
      }

      // if switching an include to exclude
      if (isAllowedNum === EAllowStatus.DENY) {
        const [currExcludedIndex, currExcludedVals] = this.getAllCurrentExcludedValuesAndIndex(
          field,
          targetFieldName,
        );
        const toIncludeVals = currExcludedVals
          .filter((v: string) => !currDisabledVals.includes(v) && v.length)
          .join(',');
        if (currExcludedIndex !== -1) {
          Destinations[currExcludedIndex][targetFieldName] = toIncludeVals;
        }
        Destinations = this.updateExcludedDestinationTarget(
          targetFieldName,
          field,
          destIndex,
          Destinations,
        );
      }

      if (Destinations.length > destIndex) {
        Destinations[destIndex][field] = isAllowedNum;
        this.setState({
          Destinations,
        });
      }
    };

    getAllCurrentExcludedValuesAndIndex = (
      field: DestinationInclusionFieldKeys,
      targetFieldName: DestinationTargetFieldKeys,
    ): [number, string[]] => {
      const Destinations = cloneDeep(this.state.Destinations);
      for (let i = 0; i < Destinations.length; i++) {
        const destination = Destinations[i];
        if (destination[field] === EAllowStatus.DENY) {
          return [i, destination[targetFieldName].split(',').filter((v: string) => v.length)];
        }
      }
      return [-1, ['']];
    };

    getAllCurrentSelectedValues = (
      inclusionFieldName: DestinationInclusionFieldKeys,
      targetFieldName: DestinationTargetFieldKeys,
      destIndex: number,
    ) => {
      const { Destinations } = this.state;
      let allValues: string[] = [];
      for (let i = 0; i < Destinations.length; i++) {
        const destination = Destinations[i];
        // ignore excluded index or if index is current target
        if (destination[inclusionFieldName] === EAllowStatus.DENY || i === destIndex) {
          continue;
        }
        if (destination[targetFieldName]) {
          allValues = allValues.concat(
            destination[targetFieldName].split(',').filter((v: string) => v.length),
          );
        }
      }
      return allValues;
    };

    handleAllRegionsModalClose = (reloadBidder?: boolean, redirectToAllRegions?: boolean) => {
      this.setState(
        {
          createEditRegionID: '',
          createEditRegionList: generateCountriesMenuList(),
          createEditRegionName: '',
          openRegionCreateEditDialog: false,
          openRegionSelectTable: !!redirectToAllRegions,
        },
        reloadBidder ? this.updateCountryGroupsByPublisherID : undefined,
      );
    };

    handleSaveEditNewRegion = (
      regionValidationErrors: IErrors,
      miscErrors: IErrors,
      createEditRegionID: string,
      newCountryGroup: ICountryGroup,
    ) => {
      if (hasErrors(regionValidationErrors)) {
        const errorText = Object.values(miscErrors)
          .filter((value) => value.length)
          .join('. ');

        this.setState(
          {
            errors: regionValidationErrors,
            snackbarMessage: `Please fix errors before saving region: ${errorText}`,
            snackbarError: true,
            snackbarWarning: false,
          },
          () => {
            this.setState({
              errors: {} as IErrors,
            });
          },
        );
        return;
      }

      if (!createEditRegionID) {
        createCountryGroup(newCountryGroup).then(() => {
          this.setState({
            snackbarError: false,
            snackbarMessage: 'Successfully created region',
            snackbarWarning: false,
          });
          this.handleAllRegionsModalClose(true, false);
        });
      } else {
        newCountryGroup.ID = parseInt(createEditRegionID, 10);
        this.setState(
          {
            updatingCountryGroup: true,
          },
          () => {
            updateCountryGroup(newCountryGroup).then(() => {
              this.setState({
                snackbarError: false,
                snackbarMessage: 'Successfully updated region',
                updatingCountryGroup: false,
                snackbarWarning: false,
              });
              this.handleAllRegionsModalClose(true, false);
            });
          },
        );
      }
    };

    // [LocalTargeting] addLocalTargetingParam handles adding a new local targeting param
    handleAddLocalTargetingParam = (destIndex: number) => {
      if (this.props.readOnly) {
        return;
      }
      const { Destinations } = this.state;
      const destinationsClone = cloneDeep(Destinations);
      const destinationToUpdate = destinationsClone[destIndex];
      destinationToUpdate.localTargetingParameters.push({
        type: 'country',
        country: '',
        states: '',
        cities: '',
        zips: '',
        dmas: '',
        isInputInCommaSeparatedMode: false,
      } as ILocalTargetingParameter);
      this.setState({
        Destinations: destinationsClone,
      });
    };

    // [LocalTargeting] updateLocalTargetingParam handles type or value change for local targeting params
    handleUpdateLocalTargetingParam = (
      destIndex: number,
      localParamIndex: number,
      updates: object,
    ) => {
      const { Destinations } = this.state;
      const destinationsClone = cloneDeep(Destinations);
      const destinationToUpdate = destinationsClone[destIndex];
      destinationToUpdate.localTargetingParameters[localParamIndex] = {
        ...destinationToUpdate.localTargetingParameters[localParamIndex],
        ...updates,
      };

      this.setState({
        Destinations: destinationsClone,
      });
    };

    // [LocalTargeting] deleteLocalTargetingParam handles deleting a local targeting param
    handleDeleteLocalTargetingParam = (destIndex: number, localParamIndex: number) => {
      const { Destinations } = this.state;
      const destinationsClone = cloneDeep(Destinations);
      const destinationToUpdate = destinationsClone[destIndex];
      destinationToUpdate.localTargetingParameters.splice(localParamIndex, 1);

      this.setState({
        Destinations: destinationsClone,
      });
    };

    // [LocalTargeting] exportLocalTargetingParamToJSON exports all the local targeting params to a json string
    exportLocalTargetingParamToJSON = () => {
      const Destinations = cloneDeep(this.state.Destinations);
      for (let i = 0; i < Destinations.length; i++) {
        const destination = Destinations[i];
        const destLocalTargParam = destination.localTargetingParameters;
        const filteredList = exportLocalTargetingToJSON(destLocalTargParam);
        destination.LocalTargeting = JSON.stringify(filteredList);
      }

      return Destinations;
    };

    handleChangeRequestPercentage = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      const index = parseInt(target.name, 10);
      const value = target.value === '' ? 0 : parseInt(target.value, 10);
      if (this.props.readOnly || Number.isNaN(value)) {
        return;
      }

      if (this.state.Destinations[index]) {
        const Destinations = cloneDeep(this.state.Destinations);
        Destinations[index].ShareOfRequests = value;
        this.setState({
          Destinations,
        });
      }
    };

    handleChangeOriginChannel = (originChannelList: IMenuList): void => {
      if (this.props.readOnly) {
        return;
      }

      this.setState({
        originChannelList,
      });
    };

    // disables backfill enabled on all except the selected destination
    handleDestinationBackfillAcceptClick = (backfillDestinationList: IMenuList): void => {
      if (this.props.readOnly) {
        return;
      }
      const Destinations = cloneDeep(this.state.Destinations);
      let selectedIndex = ''; // the menulist's ID is the index
      for (const item of Object.values(backfillDestinationList)) {
        if (item.selected) {
          selectedIndex = item.ID;
          break;
        }
      }

      for (let i = 0; i < Destinations.length; i++) {
        if (selectedIndex === i.toString()) {
          // if we set this backfill to true, we should set its share of requests and targeting parameters back to empty
          // since we will request from it regardless
          Destinations[i].BackfillEnabled = EBool.EBool_TRUE;
          Destinations[i] = this.clearDestinationTargetingAndShare(Destinations[i]);
        } else {
          Destinations[i].BackfillEnabled = EBool.EBool_FALSE;
        }
      }

      this.setState({
        Destinations,
      });
    };

    // update EndpointURL when Region is toggled
    handleChangeRegionSelect = (_: any, value: string) => {
      const { EndpointURL } = this.state;
      const apac = 'pbs-au';
      const usa = 'pbs';
      const europe = 'pbs-eu';
      let current = '';
      let prev = '';

      if (this.state.EndpointURL) {
        if (EndpointURL.includes('pbs.')) {
          prev = usa;
        } else if (EndpointURL.includes(apac)) {
          prev = apac;
        } else if (EndpointURL.includes(europe)) {
          prev = europe;
        }

        if (value === USA) {
          current = usa;
        } else if (value === EUROPE) {
          current = europe;
        } else if (value === APAC) {
          current = apac;
        }
      }

      if (value) {
        this.setState((prevState) => {
          return {
            Region: value,
            EndpointURL: prevState.EndpointURL.replace(prev, current),
          };
        });
      }
    };

    handleChangeDestinationTarget = (
      destinationType: DestinationType,
      inventoryRouteDestinationTargetList: IMenuList,
      destIndex: number,
    ): void => {
      if (this.props.readOnly) {
        return;
      }
      const Destinations = cloneDeep(this.state.Destinations);
      switch (destinationType) {
        case DestinationTypeSite:
          let newSiteID = 0;
          let newSiteUUID = '';
          for (const item of Object.values(inventoryRouteDestinationTargetList)) {
            if (item.selected) {
              newSiteID = parseInt(item.ID, 10);
              newSiteUUID = item.uuid || '';
            }
          }
          Destinations[destIndex].inventoryRouteChannelList = inventoryRouteDestinationTargetList;
          Destinations[destIndex].SiteID = newSiteID;
          Destinations[destIndex].SiteUUID = newSiteUUID;
          break;
        case DestinationTypeRoute:
          let newRouteID = 0;
          for (const item of Object.values(inventoryRouteDestinationTargetList)) {
            if (item.selected) {
              newRouteID = parseInt(item.ID, 10);
            }
          }
          Destinations[destIndex].inventoryRouteRouteList = inventoryRouteDestinationTargetList;
          Destinations[destIndex].ForwardingRouteID = newRouteID;
          break;
      }

      this.setState({
        Destinations,
      });
    };

    handleChangeVastURL = (vastURL: string, destIndex?: number) => {
      if (this.props.readOnly) {
        return;
      }

      // if updating an existing destinations VastURL
      if (destIndex !== undefined) {
        const Destinations = cloneDeep(this.state.Destinations);
        Destinations[destIndex].VastURL = vastURL;
        this.setState({
          Destinations,
        });

        // if adding new VastURL for new destination
      } else {
        this.setState({
          newVastUrl: vastURL,
        });
      }
    };

    handleChangeDestinationName = (destinationName: string, destIndex: number) => {
      if (this.props.readOnly) {
        return;
      }

      // if updating an existing destinations Name
      const Destinations = cloneDeep(this.state.Destinations);
      Destinations[destIndex].Name = destinationName;
      this.setState(
        {
          Destinations,
        },
        this.generateFallbackDestinationList,
      );
    };

    handleAddNewDestination = () => {
      if (this.props.readOnly) {
        return;
      }

      const Destinations = cloneDeep(this.state.Destinations);
      const newDestination = this.generateDestination();
      Destinations.push(newDestination);

      this.setState(
        {
          Destinations,
        },
        this.generateFallbackDestinationList,
      );
    };

    isChannelSelected = (inventoryRouteChannelList: IMenuList) => {
      for (const item of Object.values(inventoryRouteChannelList)) {
        if (item.selected) {
          return true;
        }
      }
      return false;
    };

    generateDestination = (): IDestination => {
      return {
        ID: 0,
        Name: '',
        DestinationType: DestinationTypeVastURL,
        BackfillEnabled: EBool.EBool_FALSE,
        VastURL: '',
        RouteID: this.state.ID,
        SiteID: undefined,
        SiteUUID: '',
        ShareOfRequests: 0,
        TargetingAppBundleID: '',
        TargetingAppBundleIDIsAllowed: EAllowStatus.ALLOW,
        TargetingContentChannel: '',
        TargetingContentChannelIsAllowed: EAllowStatus.ALLOW,
        TargetingContentDistributor: '',
        TargetingContentDistributorIsAllowed: EAllowStatus.ALLOW,
        TargetingContentGenre: '',
        TargetingContentGenreIsAllowed: EAllowStatus.ALLOW,
        TargetingContentID: '',
        TargetingContentIDIsAllowed: EAllowStatus.ALLOW,
        TargetingContentNetwork: '',
        TargetingContentNetworkIsAllowed: EAllowStatus.ALLOW,
        TargetingContentProducer: '',
        TargetingContentProducerIsAllowed: EAllowStatus.ALLOW,
        TargetingContentRating: '',
        TargetingContentRatingIsAllowed: EAllowStatus.ALLOW,
        TargetingContentSeries: '',
        TargetingContentSeriesIsAllowed: EAllowStatus.ALLOW,
        TargetingContentTitle: '',
        TargetingContentTitleIsAllowed: EAllowStatus.ALLOW,
        TargetingDealID: '',
        TargetingDeviceTypes: '',
        TargetingDeviceTypesIsAllowed: EAllowStatus.ALLOW,
        TargetingDeviceSubTypes: '',
        TargetingDeviceSubTypesIsAllowed: EAllowStatus.ALLOW,
        TargetingDevices: '',
        TargetingDevicesIsAllowed: EAllowStatus.ALLOW,
        TargetingCustom4: '',
        TargetingCustom4Inclusion: EAllowStatus.ALLOW,
        TargetingCustom5: '',
        TargetingCustom5Inclusion: EAllowStatus.ALLOW,
        TargetingCustom6: '',
        TargetingCustom6Inclusion: EAllowStatus.ALLOW,
        TargetingCustom7: '',
        TargetingCustom7Inclusion: EAllowStatus.ALLOW,
        TargetingCustom8: '',
        TargetingCustom8Inclusion: EAllowStatus.ALLOW,
        TargetingCustom9: '',
        TargetingCustom9Inclusion: EAllowStatus.ALLOW,
        TargetingCustom10: '',
        TargetingCustom10Inclusion: EAllowStatus.ALLOW,
        TargetingCustom11: '',
        TargetingCustom11Inclusion: EAllowStatus.ALLOW,
        TargetingCustom12: '',
        TargetingCustom12Inclusion: EAllowStatus.ALLOW,
        TargetingCustom13: '',
        TargetingCustom13Inclusion: EAllowStatus.ALLOW,
        TargetingCustom14: '',
        TargetingCustom14Inclusion: EAllowStatus.ALLOW,
        TargetingCustom15: '',
        TargetingCustom15Inclusion: EAllowStatus.ALLOW,
        TargetingCustom16: '',
        TargetingCustom16Inclusion: EAllowStatus.ALLOW,
        TargetingCustom17: '',
        TargetingCustom17Inclusion: EAllowStatus.ALLOW,
        TargetingCustom18: '',
        TargetingCustom18Inclusion: EAllowStatus.ALLOW,
        TargetingLivestream: TargetingLivestreamAll,
        TargetingWSeat: '',
        TargetingFWSectionIDs: '',
        TargetingFWSectionIDsInclusion: EAllowStatus.ALLOW,
        TargetingDeviceCountry: '',
        LocalTargeting: '',
        LocalTargetingLogic: TargetingLogicOR,
        LocalTargetingIsAllowed: EAllowStatus.ALLOW,
        localTargetingParameters: [] as ILocalTargetingParameter[],
        CountryGroups: [] as ICountryGroup[],
        TargetingDeviceCountryIsAllowed: EAllowStatus.ALLOW,
        targetingCountriesList: generateCountriesMenuList(),
        targetingCountryGroupList: generateCountryGroupMenuList(
          this.state.publisherCountryGroups,
        ) as IMenuList,
        TargetingCountryGroupIDs: '',
        TargetingCountryGroupIDsIsAllowed: EAllowStatus.ALLOW,
        TargetingCoppa: TargetingCoppaAll,
        TargetingCCPA: TargetingCCPAAll,
        TargetingLimitedAdTracking: TargetBoolTypeAll,
      } as IDestination;
    };

    addVastURLRoute = (
      Destinations: IDestination[],
      newDestinationName: string,
      newVastUrl: string,
      publisherCountryGroups: ICountryGroup[],
    ): IDestination[] => {
      // require Name and URL before adding Destination
      if (!newDestinationName || !newVastUrl) {
        this.handleSnackbarError(true, 'Destination Name and VAST url are required.');
        return Destinations;
      }

      // validate for correct URL before adding Destination
      if (!checkURL.test(newVastUrl)) {
        this.handleSnackbarError(true, `WARNING: ${newVastUrl} is not a valid URL`);
        return Destinations;
      }

      Destinations.push({
        ID: 0,
        Name: newDestinationName,
        DestinationType: DestinationTypeVastURL,
        BackfillEnabled: EBool.EBool_FALSE,
        VastURL: newVastUrl,
        RouteID: this.state.ID,
        SiteUUID: '',
        ShareOfRequests: 0,
        TargetingAppBundleID: '',
        TargetingAppBundleIDIsAllowed: EAllowStatus.ALLOW,
        TargetingContentChannel: '',
        TargetingContentChannelIsAllowed: EAllowStatus.ALLOW,
        TargetingContentDistributor: '',
        TargetingContentDistributorIsAllowed: EAllowStatus.ALLOW,
        TargetingContentGenre: '',
        TargetingContentGenreIsAllowed: EAllowStatus.ALLOW,
        TargetingContentID: '',
        TargetingContentIDIsAllowed: EAllowStatus.ALLOW,
        TargetingContentNetwork: '',
        TargetingContentNetworkIsAllowed: EAllowStatus.ALLOW,
        TargetingContentProducer: '',
        TargetingContentProducerIsAllowed: EAllowStatus.ALLOW,
        TargetingContentRating: '',
        TargetingContentRatingIsAllowed: EAllowStatus.ALLOW,
        TargetingContentSeries: '',
        TargetingContentSeriesIsAllowed: EAllowStatus.ALLOW,
        TargetingContentTitle: '',
        TargetingContentTitleIsAllowed: EAllowStatus.ALLOW,
        TargetingDealID: '',
        TargetingDeviceTypes: '',
        TargetingDeviceTypesIsAllowed: EAllowStatus.ALLOW,
        TargetingDevices: '',
        TargetingDevicesIsAllowed: EAllowStatus.ALLOW,
        TargetingCustom4: '',
        TargetingCustom4Inclusion: EAllowStatus.ALLOW,
        TargetingCustom5: '',
        TargetingCustom5Inclusion: EAllowStatus.ALLOW,
        TargetingCustom6: '',
        TargetingCustom6Inclusion: EAllowStatus.ALLOW,
        TargetingCustom7: '',
        TargetingCustom7Inclusion: EAllowStatus.ALLOW,
        TargetingCustom8: '',
        TargetingCustom8Inclusion: EAllowStatus.ALLOW,
        TargetingCustom9: '',
        TargetingCustom9Inclusion: EAllowStatus.ALLOW,
        TargetingCustom10: '',
        TargetingCustom10Inclusion: EAllowStatus.ALLOW,
        TargetingCustom11: '',
        TargetingCustom11Inclusion: EAllowStatus.ALLOW,
        TargetingCustom12: '',
        TargetingCustom12Inclusion: EAllowStatus.ALLOW,
        TargetingCustom13: '',
        TargetingCustom13Inclusion: EAllowStatus.ALLOW,
        TargetingCustom14: '',
        TargetingCustom14Inclusion: EAllowStatus.ALLOW,
        TargetingCustom15: '',
        TargetingCustom15Inclusion: EAllowStatus.ALLOW,
        TargetingCustom16: '',
        TargetingCustom16Inclusion: EAllowStatus.ALLOW,
        TargetingCustom17: '',
        TargetingCustom17Inclusion: EAllowStatus.ALLOW,
        TargetingCustom18: '',
        TargetingCustom18Inclusion: EAllowStatus.ALLOW,
        TargetingLivestream: TargetingLivestreamAll,
        TargetingWSeat: '',
        TargetingFWSectionIDs: '',
        TargetingFWSectionIDsInclusion: EAllowStatus.ALLOW,
        LocalTargeting: '',
        LocalTargetingLogic: TargetingLogicOR,
        LocalTargetingIsAllowed: EAllowStatus.ALLOW,
        localTargetingParameters: [] as ILocalTargetingParameter[],
        CountryGroups: [] as ICountryGroup[],
        TargetingDeviceCountry: '',
        TargetingDeviceCountryIsAllowed: EAllowStatus.ALLOW,
        targetingCountriesList: generateCountriesMenuList(),
        targetingCountryGroupList: generateCountryGroupMenuList(
          publisherCountryGroups,
        ) as IMenuList,
        TargetingCountryGroupIDs: '',
        TargetingCountryGroupIDsIsAllowed: EAllowStatus.ALLOW,
        TargetingCoppa: TargetingCoppaAll,
        TargetingLimitedAdTracking: TargetBoolTypeAll,
        inventoryRouteChannelList: {} as IMenuList,
      } as IDestination);

      return Destinations;
    };

    handleDeleteVastURL = (index: number) => {
      if (this.props.readOnly) {
        return;
      }

      const Destinations = cloneDeep(this.state.Destinations);
      Destinations.splice(index, 1);

      this.setState({
        Destinations,
      });
    };

    handleChangeRoutingCondition = (RoutingCondition: RoutingCondition): void => {
      this.setState({
        RoutingCondition,
      });
    };

    getDeviceEnvValsFromList = (values: IMenuList, destIndex: number) => {
      const selectedDevices = Object.values(values).filter((src: IListItem) => src.selected);
      let targetingDevices = '0';

      // if all or no devices are selected, return '0' as the value, otherwise join the values
      if (
        selectedDevices.length !==
          Object.keys(
            getDeviceEnvironmentAsItems(this.state.Destinations[destIndex].TargetingDevices),
          ).length ||
        selectedDevices.length === 0
      ) {
        targetingDevices = selectedDevices.map((src: IListItem) => src.ID).join(',');
      }
      return targetingDevices;
    };

    getDeviceEnvSubTypeValsFromList = (values: IMenuList, destIndex: number) => {
      const selectedDeviceSubTypes = Object.values(values).filter((src: IListItem) => src.selected);
      let targetingDeviceSubTypes = '0';

      // if all or no devices are selected, return '0' as the value, otherwise join the values
      if (
        selectedDeviceSubTypes.length !==
          Object.keys(
            getDeviceEnvironmentSubTypesAsItems(
              this.state.Destinations[destIndex].TargetingDeviceSubTypes,
              this.props.session.publisher.ID,
              hasRoleSuperUser(this.props.user.user),
            ),
          ).length ||
        selectedDeviceSubTypes.length === 0
      ) {
        targetingDeviceSubTypes = selectedDeviceSubTypes.map((src: IListItem) => src.ID).join(',');
      }
      return targetingDeviceSubTypes;
    };

    getDeviceTypeValsFromList = (values: IMenuList) => {
      const targetingDeviceTypes = Object.values(values)
        .filter((src: IListItem) => src.selected)
        .map((item: IListItem) => item.ID)
        .join(',');

      return targetingDeviceTypes;
    };

    getGeoValsFromList = (field: string, values: IMenuList) => {
      if (field === 'targetingCountriesList') {
        const targetingDeviceCountries = Object.values(values)
          .filter((src: IListItem) => src.selected)
          .map((item: IListItem) => item.ID.toUpperCase())
          .join(',');
        return targetingDeviceCountries;
      }

      if (field === 'targetingCountryGroupList') {
        const targetingCountryGroupIDs = Object.values(values)
          .filter((src: IListItem) => src.selected)
          .map((item: IListItem) => item.ID)
          .join(',');
        return targetingCountryGroupIDs;
      }

      return '';
    };

    handleChangeLivestream = (value: string, i: number) => {
      const Destinations = cloneDeep(this.state.Destinations);
      Destinations[i].TargetingLivestream = parseInt(value, 10);

      this.setState({
        Destinations,
      });
    };

    // -------- SNACKBAR HELPER FUNCTIONS -------- //
    handleSnackbarError = (snackbarError: boolean, snackbarMessage: string): void => {
      this.setState({
        snackbarError,
        snackbarMessage,
        snackbarWarning: false,
      });
    };

    handleSnackbarClose = (): void => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
        snackbarWarning: false,
      });
    };

    // -------- RENDER HELPER FUNCTIONS -------- //
    // NOTE: We destructure props and states used in render functions to clearly
    // show what we are passing as well as keeping the code clean and easier to read

    renderAppBar(): ReactElement {
      const { ID, Name, updating } = this.state;

      return (
        <Grid item>
          <SettingsAppBar
            name={this.isUserInfoMasked() ? `Route_${ID}` : Name}
            isActive={this.state.Active === ResourceActiveEnabled}
            hasWriteRights={this.hasWriteRights().isAuthorized}
            isUpdating={updating}
            handleNameChange={this.handleNameChange}
            handleSave={this.handleSave}
            handleClose={this.handleClose}
            handleDelete={this.handleDelete}
            handleChangeActive={this.handleChangeActive}
            relative
          />
        </Grid>
      );
    }

    renderDestinations = (): ReactElement => {
      const { classes, readOnly } = this.props;
      const { Destinations } = this.state;
      return (
        <>
          {Destinations.map((destination: any, destIndex: number) => {
            return (
              <Grid item className={classes.maxWidthGrid} style={{ marginLeft: '25px' }}>
                <ModelPrimaryContainerV2>
                  {/* Inventory Split Name */}
                  <InputGridRow
                    text='Name'
                    subText={destination.ID !== 0 ? 'ID ' + destination.ID : 'ID: New'}
                    style={{ marginLeft: '8px' }}
                    endComponent={
                      <Grid style={{ width: '250px' }}>
                        {this.renderLiveLogsForDestination(destIndex)}
                      </Grid>
                    }
                  >
                    <Grid item style={{ marginLeft: '6px' }}>
                      <ModernTextField
                        value={destination.Name}
                        disabled={!this.hasWriteRights().isAuthorized}
                        editIconSize='medium'
                        customStyle={{
                          width: '450px',
                          minWidth: '300px',
                          height: '35px',
                        }}
                        onChange={(event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                          if (this.hasWriteRights().isAuthorized) {
                            this.handleChangeDestinationName(event.target.value, destIndex);
                          }
                        }}
                      />
                    </Grid>
                  </InputGridRow>

                  {/* Demand Source */}
                  <InputGridRow text='Destination' style={{ marginTop: '15px', marginLeft: '8px' }}>
                    <Grid item style={{ marginLeft: '6px' }}>
                      <PillSwitcher
                        disabled={readOnly}
                        currentText={destinationDemandSourceTypeToString(
                          destination.DestinationType,
                        )}
                        pills={ROUTE_SOURCE_PILLS}
                        onChange={(value: string) => {
                          this.handleChangeDestinationType(destIndex, value);
                        }}
                      />
                    </Grid>
                  </InputGridRow>

                  {/* Channels or Vast URL */}
                  <Grid>
                    {destination.DestinationType === DestinationTypeSite && (
                      <Grid item>
                        {this.renderChannelDestinations(
                          destination.inventoryRouteChannelList,
                          destIndex,
                        )}
                      </Grid>
                    )}
                    {destination.DestinationType === DestinationTypeVastURL && (
                      <Grid item className={this.props.classes.maxWidthGrid}>
                        {this.renderVastDestinations(destination.VastURL, destIndex)}
                      </Grid>
                    )}
                    {destination.DestinationType === DestinationTypeRoute && (
                      <Grid item className={this.props.classes.maxWidthGrid}>
                        {this.renderInventoryRouteTypeDestinations(
                          destination.inventoryRouteRouteList,
                          destIndex,
                        )}
                      </Grid>
                    )}
                  </Grid>
                </ModelPrimaryContainerV2>
              </Grid>
            );
          })}
          {this.renderAddDestinationButton()}
        </>
      );
    };

    renderDeleteDestinationButton = (destIndex: number | undefined): ReactElement => {
      const { readOnly } = this.props;
      const isDestination = destIndex === undefined ? false : true;
      return (
        <Grid
          item
          style={{
            textAlign: 'end',
          }}
        >
          {isDestination && !readOnly && (
            <Button
              disabled={!this.hasWriteRights().isAuthorized}
              onClick={() => this.handleDeleteDestination(destIndex)}
            >
              <DeleteIcon />
            </Button>
          )}
        </Grid>
      );
    };

    renderAddDestinationButton = () => {
      const { readOnly, classes } = this.props;
      if (readOnly) {
        return <></>;
      }

      return (
        <Grid item style={{ padding: '2px', marginLeft: '20px', paddingBottom: '15px' }}>
          <Button>
            <Typography
              style={{ paddingBottom: 0, marginRight: '2px' }}
              onClick={() => this.handleAddNewDestination()}
              className={classes.addTypography}
            >
              + Add Destination To Inventory Route
            </Typography>
          </Button>
        </Grid>
      );
    };

    renderSettings = (): ReactElement => {
      const { classes, readOnly } = this.props;

      return (
        <Grid item style={{ width: '100%', marginTop: readOnly ? 0 : 10, marginLeft: 32 }}>
          <Grid container direction='column' spacing={2}>
            {/* freewheel publisher id (super user only) */}
            {this.isSuper() && (
              <Grid item>
                <Grid container direction='row' spacing={4}>
                  <Grid item>
                    <Typography
                      className={this.props.classes.typographyFontBold}
                      style={{ fontWeight: 600 }}
                    >
                      Freewheel Publisher ID *
                    </Typography>
                    <FocusedTextfield
                      fullWidth
                      multiline
                      name='FreewheelPublisherID'
                      disabled={readOnly}
                      value={this.state.FreewheelPublisherID}
                      onChange={this.handleChange}
                      helperText={'Only integers'}
                      defaultHelperText={'Only integers'}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}
            {this.isSuper() && (
              <Grid item>
                <Grid container direction='row' spacing={4}>
                  <Grid item>
                    <Typography
                      className={this.props.classes.typographyFontBold}
                      style={{ fontWeight: 600 }}
                    >
                      Timeout *
                    </Typography>
                    <FocusedTextfield
                      fullWidth
                      multiline
                      name='Timeout'
                      disabled={readOnly}
                      value={this.state.Timeout}
                      onChange={this.handleChange}
                      helperText={'Only integers'}
                      defaultHelperText={'Only integers'}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid item>
              <Grid container direction='row' spacing={4}>
                <Grid item>
                  <Typography
                    className={this.props.classes.typographyFontBold}
                    style={{ fontWeight: 600 }}
                  >
                    1. Destinations
                  </Typography>
                  <Typography variant='caption' style={{ marginLeft: '25px' }}>
                    Pick a Channel or a Vast as destinations for the traffic
                  </Typography>
                </Grid>
                {readOnly && (
                  <Grid item>
                    <ChipCompleted label='Read Only' />
                  </Grid>
                )}
              </Grid>
            </Grid>
            {this.renderDestinations()}
            {/* backfill */}
            <Grid item className={classes.maxWidthGrid}>
              {this.renderBackfill()}
            </Grid>
            {/* Routing condition */}
            <Grid item>
              <Grid container direction='column' spacing={2}>
                <Grid item>
                  <Grid container direction='row' spacing={2}>
                    <Grid item>
                      <Typography
                        className={this.props.classes.typographyFontBold}
                        style={{ fontWeight: 600 }}
                      >
                        3. Routing Condition
                      </Typography>
                    </Grid>
                    {readOnly && (
                      <Grid item>
                        <ChipCompleted label='Read Only' />
                      </Grid>
                    )}
                  </Grid>
                  <Typography variant='caption' style={{ marginLeft: '25px' }}>
                    Pick targeting <b>or</b> % of requests to set how to route traffic.
                  </Typography>
                </Grid>
                <Grid item style={{ marginLeft: '25px' }}>
                  <Grid container direction='row'>
                    <Grid item>
                      <PillSwitcher
                        disabled={readOnly}
                        currentText={inventoryRouteConditionTypeToString(
                          this.state.RoutingCondition,
                        )}
                        pills={ROUTE_CONDITION_PILLS}
                        customStyle={{ width: '130px', height: '40px', padding: '10px' }}
                        onChange={(value: string) => {
                          if (
                            value ===
                            inventoryRouteConditionTypeToString(RoutingConditionTargetingParams)
                          ) {
                            this.handleChangeRoutingCondition(RoutingConditionTargetingParams);
                          } else {
                            this.handleChangeRoutingCondition(RoutingConditionPercentageRequests);
                          }
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      className={classes.infoIconGrid}
                      style={{ marginTop: '6px', paddingLeft: '0px' }}
                    >
                      <Tooltip title='Only the selected routing condition is applied to the route'>
                        <InfoIcon style={{ width: '1rem', color: '#929599' }} />
                      </Tooltip>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {this.renderTargeting()}
          </Grid>
        </Grid>
      );
    };

    renderChannelDestinations(routeChannelList: IMenuList, destIndex: number) {
      return (
        <>
          <InputGridRow
            text='Channel'
            subText='One channel per destination.'
            style={{ marginLeft: '8px' }}
            endComponentStyle={{ alignSelf: 'flex-end' }}
            endComponent={
              <Grid item style={{ paddingRight: '15px', paddingTop: '15px', alignItems: 'end' }}>
                {this.renderDeleteDestinationButton(destIndex)}
              </Grid>
            }
          >
            <Grid item style={{ paddingLeft: '8px' }}>
              <MaterialSearchDropdownMulti
                width='450px'
                fontSize='16px'
                selectLimit={1}
                enableMultiSelect={false}
                menuTitle='Destination Channel'
                list={routeChannelList}
                onChange={(channelList) =>
                  this.handleChangeDestinationTarget(DestinationTypeSite, channelList, destIndex)
                }
                maxHeight={350}
              />
            </Grid>
          </InputGridRow>
        </>
      );
    }

    renderVastDestinations(vastURL: string, destIndex?: number) {
      const { readOnly, session } = this.props;
      return (
        <InputGridRow
          text='VAST Url'
          subText='Replace macros to dynamically populate the values'
          style={{
            marginBottom: 0,
            paddingLeft: '8px',
          }}
          endComponentStyle={{ alignSelf: 'flex-end' }}
          endComponent={this.renderDeleteDestinationButton(destIndex)}
        >
          <Grid
            style={{
              background: !readOnly ? 'aliceblue' : 'rgba(203,203,203,0.31)',
              borderRadius: smallRadius,
              opacity: '1',
              paddingLeft: '10px',
              paddingRight: '10px',
              width: '100%',
            }}
          >
            <VastEditor
              url={vastURL}
              urlID={0}
              highlight={(code) => highlight(code, languages.elm, 'elm')}
              padding={8}
              maxLength={2000}
              onURLChange={(url) => this.handleChangeVastURL(url, destIndex)}
              textStyle={{
                background: 'aliceblue',
                borderRadius: smallRadius,
                opacity: '1',
                marginBottom: '5px',
              }}
              wikiMsgHidden={session.publisher.Reseller && session.publisher.Reseller.ID === '4'}
              disabled={readOnly}
              placeholder={'Enter Vast URL'}
              disableSiteIDMacro={isPBSDomain(vastURL)}
              style={{
                padding: '5px 10px',
              }}
            />
          </Grid>
        </InputGridRow>
      );
    }

    renderInventoryRouteTypeDestinations(routeRouteList: IMenuList, destIndex: number) {
      return (
        <>
          <InputGridRow
            text='Route'
            subText='Inventory route to receive this inventory'
            style={{ marginLeft: '8px' }}
            endComponentStyle={{ alignSelf: 'flex-end' }}
            endComponent={
              <Grid item style={{ paddingRight: '15px', paddingTop: '15px', alignItems: 'end' }}>
                {this.renderDeleteDestinationButton(destIndex)}
              </Grid>
            }
          >
            <Grid item style={{ paddingLeft: '8px' }}>
              <MaterialSearchDropdownMulti
                width='450px'
                fontSize='16px'
                selectLimit={1}
                enableMultiSelect={false}
                menuTitle='Destination Route'
                list={routeRouteList}
                onChange={(routeList) =>
                  this.handleChangeDestinationTarget(DestinationTypeRoute, routeList, destIndex)
                }
                maxHeight={350}
              />
            </Grid>
          </InputGridRow>
        </>
      );
    }

    renderBackfill() {
      const { readOnly, classes } = this.props;
      const { backfillDestinationList, isBackfillEnabled } = this.state;
      return (
        <Grid container direction='column'>
          {/* title row */}
          <Grid item>
            <Grid container direction='row' spacing={2}>
              <Grid item>
                <Typography
                  className={this.props.classes.typographyFontBold}
                  style={{ fontWeight: 600 }}
                >
                  2. Option
                </Typography>
              </Grid>
              {readOnly && (
                <Grid item>
                  <ChipCompleted label='Read Only' />
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item style={{ margin: '10px 0 10px 25px' }}>
            <Grid container direction='row' spacing={2} alignItems='center'>
              <Grid item>
                <Typography className={this.props.classes.typographyFontBold}>
                  Enable Backfill
                </Typography>
              </Grid>
              <Grid
                item
                className={classes.infoIconGrid}
                style={{ marginTop: '6px', paddingLeft: '0px' }}
              >
                <Tooltip
                  title='A backfill destination will be called in parallel with the destination selected by % of requests or targeting. If the selected destination fails to fill, the backfill response will be used instead'
                  placement='bottom-start'
                >
                  <InfoIcon style={{ width: '1rem', color: '#929599' }} />
                </Tooltip>
              </Grid>
              <Grid item>
                <Switch
                  name='isBackfillEnabled'
                  checked={isBackfillEnabled}
                  onChange={(e) => this.handleChange(e)}
                />
              </Grid>
              {isBackfillEnabled && (
                <Grid item>
                  <Typography className={this.props.classes.typographyFontBold}>Active</Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
          {isBackfillEnabled && (
            <Grid item style={{ marginLeft: '25px' }}>
              <MaterialSearchDropdownMulti
                enableMultiSelect={false}
                selectLimit={1}
                menuTitle='Backfill Destination'
                list={backfillDestinationList}
                onChange={(backfillDestinationList: IMenuList) =>
                  this.setState({ backfillDestinationList })
                }
                handleMenuAcceptClick={this.handleDestinationBackfillAcceptClick}
              />
            </Grid>
          )}
        </Grid>
      );
    }

    renderTargeting() {
      const { classes } = this.props;
      const { FreewheelPublisherID } = this.state;
      if (this.state.RoutingCondition === RoutingConditionTargetingParams) {
        const targetingDescription1 =
          FreewheelPublisherID === null
            ? 'Enter targeting parameters for the destinations. Only one targeting param can be selected across all destinations'
            : 'Enter targeting parameters for the destinations. For Freewheel, the destination with the most matched targeted params will be selected. If there is a tie, the destination with no targeting is used as a fallback.';
        const targetingDescription2 =
          FreewheelPublisherID === null
            ? 'ex. only Content Title values can be entered for all destinations, no other fields may be used'
            : 'ex. Destination 1 has a Custom 4 and Custom 5 value that matches and Destination 2 has a Custom 4 value that matches. Destination 1 is selected.';
        return (
          <Grid item style={{ marginLeft: '25px' }}>
            <Grid container direction='column' spacing={2} className={classes.maxWidthGrid}>
              <Grid item>
                <Typography className={this.props.classes.insideAccordionText}>
                  <b>{targetingDescription1}</b>
                  <br /> {targetingDescription2}
                </Typography>
              </Grid>
              <Grid item>{this.renderTargetingParameters()}</Grid>
            </Grid>
          </Grid>
        );
      } else {
        return (
          <Grid item style={{ marginLeft: '25px' }}>
            <Grid container direction='column' spacing={2}>
              <Grid item>
                <Typography className={this.props.classes.insideAccordionText}>
                  Set the percentage of requests that should be sent to each destination
                </Typography>
              </Grid>
              <Grid item>{this.renderPercentageRequests()}</Grid>
            </Grid>
          </Grid>
        );
      }
    }

    renderLocalTargetingPanel = (
      destination: IDestination,
      destIndex: number,
      localTargetingIsAllowed: boolean,
    ) => {
      const writeAuthorization = IS_AUTHORIZED(['write_inventory_route'], this.props.user.user);
      return (
        <LocalTargeting
          isCloneOrBulkUpdate={false}
          localTargetingParameters={destination.localTargetingParameters}
          LocalTargetingIsAllowed={localTargetingIsAllowed}
          LocalTargetingLogic={destination.LocalTargetingLogic}
          localTargetingLogicFieldName='LocalTargetingLogic'
          addLocalTargetingParam={() => this.handleAddLocalTargetingParam(destIndex)}
          resourceName='Destination'
          disabled={!writeAuthorization.isAuthorized}
          handleChange={this.handleChange}
          updateLocalTargetingParam={(paramIndex: number, updates: object) =>
            this.handleUpdateLocalTargetingParam(destIndex, paramIndex, updates)
          }
          deleteLocalTargetingParam={(paramIndex: number) =>
            this.handleDeleteLocalTargetingParam(destIndex, paramIndex)
          }
          titleOverride={destination.Name}
          enableMultipleLocalTargeting={true}
          multipleLocalTargetingIndex={destIndex}
        />
      );
    };

    renderCustomToolbar = (props: any): ReactElement => {
      const { classes } = this.props;
      const { updatingCountryGroup } = this.state;

      const copyProps = {
        ...props,
        searchFieldStyle: { ...props.searchFieldStyle, marginLeft: '-48px', width: '300px' },
      };

      return (
        <Grid item className={classes.toolbarRow}>
          <Grid container direction='row' justify='space-between' alignItems='center'>
            <Grid item>
              <MTableToolbar {...copyProps} />
            </Grid>
            <RowButton
              right={
                <ButtonView
                  onClick={() => {
                    this.setState({
                      openRegionSelectTable: false,
                      openRegionCreateEditDialog: true,
                    });
                  }}
                  text='+ New Region'
                  active={updatingCountryGroup}
                />
              }
            />
          </Grid>
        </Grid>
      );
    };

    generateAppBundleRows = (): IInputRow[] => {
      const targetFieldName = 'TargetingAppBundleID' as DestinationTargetFieldKeys;
      const isAllowedName = 'TargetingAppBundleIDIsAllowed' as DestinationInclusionFieldKeys;
      const inputRows = [] as IInputRow[];
      for (let i = 0; i < this.state.Destinations.length; i++) {
        const destination = this.state.Destinations[i];
        if (destination.BackfillEnabled === EBool.EBool_TRUE) {
          continue;
        }
        const isAllowed = destination[isAllowedName] === EAllowStatus.ALLOW;
        inputRows.push({
          renderType: 'AutocompleteAndIncludeRow',
          title1: destination.Name,
          field1: 'TargetingAppBundleID',
          value1: destination.TargetingAppBundleID,
          disabledvalues1: isAllowed
            ? []
            : this.genDisabledDestinationValues(targetFieldName, isAllowedName),
          value2: isAllowed,
          handleChange1: (e) => {
            const currValues = destination[targetFieldName]
              .split(',')
              .filter((v: string) => v.length);
            const newVals = e.target.value.split(',').filter((v: string) => v.length);
            const filteredCSVals = this.filterExcludedField(
              currValues,
              newVals,
              targetFieldName,
              isAllowedName,
              isAllowed,
            );
            if (filteredCSVals === null) {
              return;
            }
            const isDeleting =
              currValues.length > filteredCSVals.split(',').filter((v: string) => v.length).length;
            if (
              isDeleting ||
              this.isUniqueDestinationValue(
                targetFieldName,
                filteredCSVals,
                currValues,
                isAllowedName,
              )
            ) {
              this.handleChangeDestinationField(targetFieldName, i, filteredCSVals, isDeleting);
            }
          },
          isActiveValue1: () => destination.TargetingAppBundleID !== '',
          getActiveTag1: () => ' ',
          placeholderText: 'Enter App Bundle ID here, comma separated',
          disabled1: this.props.readOnly,
          handleChange2: () =>
            this.handleChangeDestinationInclusion(
              isAllowedName,
              i,
              isAllowed ? EAllowStatus.DENY : EAllowStatus.ALLOW,
            ),
          tooltipText: (
            <div>
              App Bundle ID to bid on
              <br />- Android: com.hulu.plus
              <br />- Apple TV: 482066631
              <br />- Roku: 12
              <br />- Fire TV: B004U7BXBO
              <br />- Samsung: G15115002089
              <br /> More info{' '}
              <a
                href='https://iabtechlab.com/wp-content/uploads/2020/08/IAB-Tech-Lab-OTT-store-assigned-App-Identification-Guidelines-2020.pdf'
                rel='noopener'
                target='_blank'
              >
                here
              </a>
            </div>
          ),
          isInventoryRoutingPage: true,
        } as IInputRow);
      }
      return inputRows;
    };

    generateContentRows = (): ITabRow[] => {
      const tabRows = [] as ITabRow[];
      const contentFields = [
        'TargetingContentChannel',
        'TargetingContentDistributor',
        'TargetingContentGenre',
        'TargetingContentID',
        'TargetingContentNetwork',
        'TargetingContentProducer',
        'TargetingContentRating',
        'TargetingContentSeries',
        'TargetingContentTitle',
      ];
      for (const contentField of contentFields) {
        const contentRows = [] as IInputRow[];
        const contentTitle = contentField.slice(16, contentField.length);
        for (let i = 0; i < this.state.Destinations.length; i++) {
          const destination = this.state.Destinations[i];
          if (destination.BackfillEnabled === EBool.EBool_TRUE) {
            continue;
          }
          const isAllowedName = `${contentField}IsAllowed` as DestinationInclusionFieldKeys;
          const isAllowed = destination[isAllowedName] === EAllowStatus.ALLOW;
          contentRows.push({
            renderType: 'AutocompleteAndIncludeRow',
            title1: destination.Name,
            field1: contentField,
            value1: destination[contentField as DestinationTargetFieldKeys],
            disabledvalues1: isAllowed
              ? []
              : this.genDisabledDestinationValues(
                  contentField as DestinationTargetFieldKeys,
                  isAllowedName,
                ),
            value2: isAllowed,
            handleChange1: (e) => {
              const currValues = destination[contentField as DestinationTargetFieldKeys]
                .split(',')
                .filter((v: string) => v.length);
              const newVals = e.target.value.split(',').filter((v: string) => v.length);
              const filteredCSVals = this.filterExcludedField(
                currValues,
                newVals,
                contentField as DestinationTargetFieldKeys,
                isAllowedName,
                isAllowed,
              );
              if (filteredCSVals === null) {
                return;
              }
              const isDeleting =
                currValues.length >
                filteredCSVals.split(',').filter((v: string) => v.length).length;
              if (
                isDeleting ||
                this.isUniqueDestinationValue(
                  contentField as DestinationTargetFieldKeys,
                  filteredCSVals,
                  currValues,
                  isAllowedName,
                )
              ) {
                this.handleChangeDestinationField(
                  contentField as DestinationTargetFieldKeys,
                  i,
                  filteredCSVals,
                  isDeleting,
                );
              }
            },
            handleChange2: () =>
              this.handleChangeDestinationInclusion(
                isAllowedName,
                i,
                isAllowed ? EAllowStatus.DENY : EAllowStatus.ALLOW,
              ),
            isActiveValue1: () => destination[contentField as DestinationTargetFieldKeys] !== '',
            getActiveTag1: () => ' ',
            placeholderText: `Enter ${contentTitle} here, comma separated`,
            disabled1: this.props.readOnly,
            isInventoryRoutingPage: true,
          } as IInputRow);
        }
        tabRows.push({
          tabName: contentTitle,
          rows: contentRows,
        } as ITabRow);
      }

      return tabRows;
    };

    generateDealIDRows = (): ITabRow[] => {
      const tabRows = [] as ITabRow[];

      const dealIDRows = [] as IInputRow[];
      const targetFieldName = 'TargetingDealID' as DestinationTargetFieldKeys;
      for (let i = 0; i < this.state.Destinations.length; i++) {
        const destination = this.state.Destinations[i];
        if (destination.BackfillEnabled === EBool.EBool_TRUE) {
          continue;
        }
        dealIDRows.push({
          renderType: 'AutocompleteAndIncludeRow',
          title1: destination.Name,
          field1: targetFieldName,
          value1: destination.TargetingDealID,
          handleChange1: (e) => {
            const currValues = destination[targetFieldName as DestinationTargetFieldKeys]
              .split(',')
              .filter((v: string) => v.length);
            const isDeleting =
              destination[targetFieldName].split(',').filter((v: string) => v.length).length >
              e.target.value.split(',').filter((v: string) => v.length).length;
            if (
              isDeleting ||
              this.isUniqueDestinationValue(targetFieldName, e.target.value, currValues)
            ) {
              this.handleChangeDestinationField(targetFieldName, i, e.target.value, isDeleting);
            }
          },
          isActiveValue1: () => destination.TargetingDealID !== '',
          getActiveTag1: () => ' ',
          placeholderText: 'Enter Deal ID here, comma separated',
          disabled1: this.props.readOnly,
        } as IInputRow);
      }
      tabRows.push({
        tabName: 'Deal IDs',
        rows: dealIDRows,
      } as ITabRow);

      if (this.state.FreewheelPublisherID) {
        const fwSectionIDRows = [] as IInputRow[];
        const targetFieldName = 'TargetingFWSectionIDs' as DestinationTargetFieldKeys;
        const targetFieldInclusionName =
          'TargetingFWSectionIDsInclusion' as DestinationInclusionFieldKeys;
        for (let i = 0; i < this.state.Destinations.length; i++) {
          const destination = this.state.Destinations[i];
          if (destination.BackfillEnabled === EBool.EBool_TRUE) {
            continue;
          }
          const isIncluded = destination[targetFieldInclusionName] === EAllowStatus.ALLOW;
          fwSectionIDRows.push({
            renderType: 'AutocompleteAndIncludeRow',
            title1: destination.Name,
            field1: targetFieldName,
            value1: destination[targetFieldName],
            disabledvalues1: isIncluded
              ? []
              : this.genDisabledDestinationValues(targetFieldName, targetFieldInclusionName),
            value2: isIncluded,
            handleChange1: (e) => {
              const currValues = destination[targetFieldName]
                .split(',')
                .filter((v: string) => v.length);
              const newVals = e.target.value.split(',').filter((v: string) => v.length);
              const filteredCSVals = this.filterExcludedField(
                currValues,
                newVals,
                targetFieldName,
                targetFieldInclusionName,
                isIncluded,
              );
              if (filteredCSVals === null) {
                return;
              }
              const isDeleting =
                currValues.length >
                filteredCSVals.split(',').filter((v: string) => v.length).length;
              if (
                isDeleting ||
                this.isUniqueDestinationValue(
                  targetFieldName,
                  filteredCSVals,
                  currValues,
                  targetFieldInclusionName,
                )
              ) {
                this.handleChangeDestinationField(targetFieldName, i, filteredCSVals, isDeleting);
              }
            },
            handleChange2: () =>
              this.handleChangeDestinationInclusion(
                targetFieldInclusionName,
                i,
                isIncluded ? EAllowStatus.DENY : EAllowStatus.ALLOW,
              ),
            isActiveValue1: () => destination[targetFieldName] !== '',
            getActiveTag1: () => ' ',
            placeholderText: `Enter Freewheel Section IDs here, comma separated`,
            disabled1: this.props.readOnly,
            isInventoryRoutingPage: true,
          } as IInputRow);
        }
        tabRows.push({
          tabName: 'Freewheel Section IDs',
          rows: fwSectionIDRows,
        } as ITabRow);
      }

      return tabRows;
    };

    generateDeviceRows = (): ITabRow[] => {
      const tabRows = [] as ITabRow[];
      // device environment rows
      const deviceEnvRows = [] as IInputRow[];
      const targetingDevicesName = 'TargetingDevices' as DestinationTargetFieldKeys;
      const targetingDevicesIsAllowedName =
        'TargetingDevicesIsAllowed' as DestinationInclusionFieldKeys;
      for (let i = 0; i < this.state.Destinations.length; i++) {
        const destination = this.state.Destinations[i];
        if (destination.BackfillEnabled === EBool.EBool_TRUE) {
          continue;
        }
        const currValues = destination[targetingDevicesName]
          .split(',')
          .filter((v: string) => v.length);
        const isAllowed = destination[targetingDevicesIsAllowedName] === EAllowStatus.ALLOW;
        let disabledTargetingDevicesValues = this.genDisabledDestinationValues(
          targetingDevicesName,
          targetingDevicesIsAllowedName,
        );
        const allOtherSelectedDeviceIDs = this.getAllCurrentSelectedValues(
          targetingDevicesIsAllowedName,
          targetingDevicesName,
          i,
        );
        if (isAllowed) {
          disabledTargetingDevicesValues = allOtherSelectedDeviceIDs.filter(
            (val: string) => !currValues.includes(val),
          );
        }

        deviceEnvRows.push({
          renderType: 'MaterialDropdown',
          title1: destination.Name,
          materialDropdownTitle: 'Device Environment(s)',
          materialDropdownTitleOverride:
            destination.TargetingDevices.length === 0
              ? 'Select a Device Environment'
              : 'Device Environment(s)',
          value1: getDeviceEnvAsItemsAndDisable(
            destination.TargetingDevices,
            disabledTargetingDevicesValues,
          ),
          value2: isAllowed,
          handleChange1: (values: IMenuList) => {
            const newVals = this.getDeviceEnvValsFromList(values, i)
              .split(',')
              .filter((v: string) => v.length);
            const filteredCSVals = this.filterExcludedField(
              currValues,
              newVals,
              targetingDevicesName as DestinationTargetFieldKeys,
              targetingDevicesIsAllowedName,
              isAllowed,
            );
            if (filteredCSVals === null) {
              return;
            }
            const isDeselecting =
              currValues.length > filteredCSVals.split(',').filter((v: string) => v.length).length;
            if (
              isDeselecting ||
              this.isUniqueDestinationValue(
                targetingDevicesName as DestinationTargetFieldKeys,
                filteredCSVals,
                currValues,
                targetingDevicesIsAllowedName,
              )
            ) {
              this.handleChangeDestinationField(
                targetingDevicesName as DestinationTargetFieldKeys,
                i,
                filteredCSVals,
                isDeselecting,
              );
            }
          },
          handleChange2: () =>
            this.handleChangeDestinationInclusion(
              targetingDevicesIsAllowedName,
              i,
              isAllowed ? EAllowStatus.DENY : EAllowStatus.ALLOW,
            ),
          isActiveValue1: () =>
            destination.TargetingDevices.split(',').length !== 0 &&
            destination.TargetingDevices !== '',
          getActiveTag1: () => ' ',
          disabled1: this.props.readOnly,
          disableSelectAll: true,
          isNoneSelectedAllSelected: true,
          isInventoryRoutingPage: true,
        } as IInputRow);
      }
      tabRows.push({
        tabName: 'Device Env',
        rows: deviceEnvRows,
      } as ITabRow);

      // device environment subtype rows
      const deviceEnvSubTypeRows = [] as IInputRow[];
      const targetingDeviceSubTypesName = 'TargetingDeviceSubTypes' as DestinationTargetFieldKeys;
      const targetingDeviceSubTypesIsAllowedName =
        'TargetingDeviceSubTypesIsAllowed' as DestinationInclusionFieldKeys;
      for (let i = 0; i < this.state.Destinations.length; i++) {
        const destination = this.state.Destinations[i];
        if (destination.BackfillEnabled === EBool.EBool_TRUE) {
          continue;
        }
        const currValues = destination[targetingDeviceSubTypesName]
          .split(',')
          .filter((v: string) => v.length);
        const isAllowed = destination[targetingDeviceSubTypesIsAllowedName] === EAllowStatus.ALLOW;
        let disabledTargetingDevicesValues = this.genDisabledDestinationValues(
          targetingDeviceSubTypesName,
          targetingDeviceSubTypesIsAllowedName,
        );
        const allOtherSelectedDeviceIDs = this.getAllCurrentSelectedValues(
          targetingDeviceSubTypesIsAllowedName,
          targetingDeviceSubTypesName,
          i,
        );
        if (isAllowed) {
          disabledTargetingDevicesValues = allOtherSelectedDeviceIDs.filter(
            (val: string) => !currValues.includes(val),
          );
        }

        deviceEnvSubTypeRows.push({
          renderType: 'MaterialDropdown',
          title1: destination.Name,
          materialDropdownTitle: 'Device Subtype(s)',
          value1: getDeviceEnvSubTypesAsItemsAndDisable(
            destination.TargetingDeviceSubTypes,
            this.props.session.publisher.ID,
            hasRoleSuperUser(this.props.user.user),
            disabledTargetingDevicesValues,
          ),
          value2: isAllowed,
          handleChange1: (values: IMenuList) => {
            const newVals = this.getDeviceEnvSubTypeValsFromList(values, i)
              .split(',')
              .filter((v: string) => v.length);
            const filteredCSVals = this.filterExcludedField(
              currValues,
              newVals,
              targetingDeviceSubTypesName as DestinationTargetFieldKeys,
              targetingDeviceSubTypesIsAllowedName,
              isAllowed,
            );
            if (filteredCSVals === null) {
              return;
            }
            const isDeselecting =
              currValues.length > filteredCSVals.split(',').filter((v: string) => v.length).length;
            if (
              isDeselecting ||
              this.isUniqueDestinationValue(
                targetingDeviceSubTypesName as DestinationTargetFieldKeys,
                filteredCSVals,
                currValues,
                targetingDeviceSubTypesIsAllowedName,
              )
            ) {
              this.handleChangeDestinationField(
                targetingDeviceSubTypesName as DestinationTargetFieldKeys,
                i,
                filteredCSVals,
                isDeselecting,
              );
            }
          },
          handleChange2: () =>
            this.handleChangeDestinationInclusion(
              targetingDeviceSubTypesIsAllowedName,
              i,
              isAllowed ? EAllowStatus.DENY : EAllowStatus.ALLOW,
            ),
          isActiveValue1: () =>
            destination.TargetingDeviceSubTypes.split(',').length !== 0 &&
            destination.TargetingDeviceSubTypes !== '',
          getActiveTag1: () => ' ',
          disabled1: this.props.readOnly,
          disableSelectAll: true,
          isNoneSelectedAllSelected: true,
          isInventoryRoutingPage: true,
        } as IInputRow);
      }
      const deviceEnvironmentSubTypes = getDeviceEnvironmentSubTypes(
        this.props.session.publisher.ID,
        hasRoleSuperUser(this.props.user.user),
      );
      if (deviceEnvironmentSubTypes.length > 0) {
        tabRows.push({
          tabName: 'Device Subtypes',
          rows: deviceEnvSubTypeRows,
        } as ITabRow);
      }

      // device type rows
      const deviceTypeRows = [] as IInputRow[];
      const targetingDeviceTypesName = 'TargetingDeviceTypes' as DestinationTargetFieldKeys;
      const targetingDeviceTypesIsAllowedName =
        'TargetingDeviceTypesIsAllowed' as DestinationInclusionFieldKeys;
      for (let i = 0; i < this.state.Destinations.length; i++) {
        const destination = this.state.Destinations[i];
        if (destination.BackfillEnabled === EBool.EBool_TRUE) {
          continue;
        }
        const currValues = destination[targetingDeviceTypesName]
          .split(',')
          .filter((v: string) => v.length);
        const isAllowed = destination[targetingDeviceTypesIsAllowedName] === EAllowStatus.ALLOW;
        let disabledTargetingDeviceTypeValues = this.genDisabledDestinationValues(
          targetingDeviceTypesName,
          targetingDeviceTypesIsAllowedName,
        );
        const allOtherSelectedDeviceTypes = this.getAllCurrentSelectedValues(
          targetingDeviceTypesIsAllowedName,
          targetingDeviceTypesName,
          i,
        );
        if (isAllowed) {
          disabledTargetingDeviceTypeValues = allOtherSelectedDeviceTypes.filter(
            (val: string) => !currValues.includes(val),
          );
        }

        deviceTypeRows.push({
          renderType: 'MaterialDropdown',
          title1: destination.Name,
          materialDropdownTitle: 'Device Type(s)',
          value1: genDeviceTypeMenuListWithSelectedAndDisable(
            destination.TargetingDeviceTypes,
            disabledTargetingDeviceTypeValues,
          ),
          value2: isAllowed,
          handleChange1: (values: IMenuList) => {
            const newVals = this.getDeviceTypeValsFromList(values)
              .split(',')
              .filter((v: string) => v.length);
            const filteredCSVals = this.filterExcludedField(
              currValues,
              newVals,
              targetingDeviceTypesName as DestinationTargetFieldKeys,
              targetingDeviceTypesIsAllowedName,
              isAllowed,
            );
            if (filteredCSVals === null) {
              return;
            }
            const isDeselecting =
              currValues.length > filteredCSVals.split(',').filter((v: string) => v.length).length;
            if (
              isDeselecting ||
              this.isUniqueDestinationValue(
                targetingDeviceTypesName as DestinationTargetFieldKeys,
                filteredCSVals,
                currValues,
                targetingDeviceTypesIsAllowedName,
              )
            ) {
              this.handleChangeDestinationField(
                targetingDeviceTypesName as DestinationTargetFieldKeys,
                i,
                filteredCSVals,
                isDeselecting,
              );
            }
          },
          handleChange2: () =>
            this.handleChangeDestinationInclusion(
              targetingDeviceTypesIsAllowedName,
              i,
              isAllowed ? EAllowStatus.DENY : EAllowStatus.ALLOW,
            ),
          isActiveValue1: () =>
            destination.TargetingDeviceTypes !== '' &&
            destination.TargetingDeviceTypes.split(',').length !== 0 &&
            destination.TargetingDeviceTypes.split(',').length !== deviceORTBTypes.length,
          getActiveTag1: () => ' ',
          disabled1: this.props.readOnly,
          disableSelectAll: true,
          isNoneSelectedAllSelected: true,
          isInventoryRoutingPage: true,
        } as IInputRow);
      }
      tabRows.push({
        tabName: 'Device Type',
        rows: deviceTypeRows,
      } as ITabRow);

      return tabRows;
    };

    generateEndpointParamRows = (): ITabRow[] => {
      const tabRows = [] as ITabRow[];
      const customFields = [
        'TargetingCustom4',
        'TargetingCustom5',
        'TargetingCustom6',
        'TargetingCustom7',
        'TargetingCustom8',
        'TargetingCustom9',
        'TargetingCustom10',
        'TargetingCustom11',
        'TargetingCustom12',
        'TargetingCustom13',
        'TargetingCustom14',
        'TargetingCustom15',
        'TargetingCustom16',
        'TargetingCustom17',
        'TargetingCustom18',
      ];
      for (const customField of customFields) {
        const customRows = [] as IInputRow[];
        const customTitle = customField.slice(9, customField.length);
        for (let i = 0; i < this.state.Destinations.length; i++) {
          const destination = this.state.Destinations[i];
          if (destination.BackfillEnabled === EBool.EBool_TRUE) {
            continue;
          }
          const isAllowedName = `${customField}Inclusion` as DestinationInclusionFieldKeys;
          const isAllowed = destination[isAllowedName] === EAllowStatus.ALLOW;
          customRows.push({
            renderType: 'AutocompleteAndIncludeRow',
            title1: destination.Name,
            field1: customField,
            value1: destination[customField as DestinationTargetFieldKeys],
            disabledvalues1: isAllowed
              ? []
              : this.genDisabledDestinationValues(
                  customField as DestinationTargetFieldKeys,
                  isAllowedName,
                ),
            value2: isAllowed,
            handleChange1: (e) => {
              const currValues = destination[customField as DestinationTargetFieldKeys]
                .split(',')
                .filter((v: string) => v.length);
              const newVals = e.target.value.split(',').filter((v: string) => v.length);
              const filteredCSVals = this.filterExcludedField(
                currValues,
                newVals,
                customField as DestinationTargetFieldKeys,
                isAllowedName,
                isAllowed,
              );
              if (filteredCSVals === null) {
                return;
              }
              const isDeleting =
                currValues.length >
                filteredCSVals.split(',').filter((v: string) => v.length).length;
              if (
                isDeleting ||
                this.isUniqueDestinationValue(
                  customField as DestinationTargetFieldKeys,
                  filteredCSVals,
                  currValues,
                  isAllowedName,
                )
              ) {
                this.handleChangeDestinationField(
                  customField as DestinationTargetFieldKeys,
                  i,
                  filteredCSVals,
                  isDeleting,
                );
              }
            },
            handleChange2: () =>
              this.handleChangeDestinationInclusion(
                isAllowedName,
                i,
                isAllowed ? EAllowStatus.DENY : EAllowStatus.ALLOW,
              ),
            isActiveValue1: () => destination[customField as DestinationTargetFieldKeys] !== '',
            getActiveTag1: () => ' ',
            placeholderText: `Enter ${customTitle} here, comma separated`,
            disabled1: this.props.readOnly,
            isInventoryRoutingPage: true,
          } as IInputRow);
        }
        tabRows.push({
          tabName: customTitle,
          rows: customRows,
        } as ITabRow);
      }

      return tabRows;
    };

    generateGeoRows = (): ITabRow[] => {
      const { user } = this.props;
      const { Destinations, publisherCountryGroups } = this.state;
      const writeAuthorization = IS_AUTHORIZED(['write_inventory_route'], user.user);
      const tabRows = [] as ITabRow[];
      let firstNonBackfillIndex = 0;
      for (let i = 0; i < Destinations.length; i++) {
        if (Destinations[i].BackfillEnabled === EBool.EBool_FALSE) {
          firstNonBackfillIndex = i;
          break;
        }
      }
      // find first index that find the first nonBackfill
      // device environment rows
      const targetedCountriesRows = [] as IInputRow[];
      for (let i = 0; i < Destinations.length; i++) {
        const destination = Destinations[i];
        if (destination.BackfillEnabled === EBool.EBool_TRUE) {
          continue;
        }
        const countriesCount = Object.values(destination.targetingCountriesList).filter(
          (item) => item.selected,
        ).length;
        const targetingCountriesName = 'TargetingDeviceCountry' as DestinationTargetFieldKeys;
        const targetingCountriesIsAllowedName =
          'TargetingDeviceCountryIsAllowed' as DestinationInclusionFieldKeys;
        const isAllowed = destination[targetingCountriesIsAllowedName] === EAllowStatus.ALLOW;

        const currValues = destination[targetingCountriesName]
          .split(',')
          .filter((v: string) => v.length);
        let disabledTargetingCountriesValues = this.genDisabledDestinationValues(
          targetingCountriesName,
          targetingCountriesIsAllowedName,
        );
        const allOtherSelectedCountries = this.getAllCurrentSelectedValues(
          targetingCountriesIsAllowedName,
          targetingCountriesName,
          i,
        );
        if (isAllowed) {
          disabledTargetingCountriesValues = allOtherSelectedCountries.filter(
            (val: string) => !currValues.includes(val),
          );
        }

        targetedCountriesRows.push({
          renderType: 'MaterialDropdown',
          title1: destination.Name,
          materialDropdownTitle: countriesCount === 1 ? 'Country' : 'Countries',
          value1: genCountriesMenuListFromSelectedAndDisable(
            destination.TargetingDeviceCountry,
            disabledTargetingCountriesValues,
          ),
          handleChange1: (values: IMenuList) => {
            const newVals = this.getGeoValsFromList('targetingCountriesList', values)
              .split(',')
              .filter((v: string) => v.length);
            const filteredCSVals = this.filterExcludedField(
              currValues,
              newVals,
              targetingCountriesName as DestinationTargetFieldKeys,
              targetingCountriesIsAllowedName,
              isAllowed,
            );
            if (filteredCSVals === null) {
              return;
            }
            const isDeselecting =
              currValues.length > filteredCSVals.split(',').filter((v: string) => v.length).length;
            if (
              isDeselecting ||
              this.isUniqueDestinationValue(
                targetingCountriesName as DestinationTargetFieldKeys,
                filteredCSVals,
                currValues,
                targetingCountriesIsAllowedName,
              )
            ) {
              this.handleChangeDestinationField(
                targetingCountriesName as DestinationTargetFieldKeys,
                i,
                filteredCSVals,
                isDeselecting,
              );
            }
          },
          handleAccept1: () => null,
          isActiveValue1: () => destination.TargetingDeviceCountry !== '',
          getActiveTag1: () => '',
          value2: isAllowed,
          disableSelectAll: true,
          handleChange2: () =>
            this.handleChangeDestinationInclusion(
              targetingCountriesIsAllowedName,
              i,
              isAllowed ? EAllowStatus.DENY : EAllowStatus.ALLOW,
            ),
          // if no countries are selected, all countries are selected (optional material search dropdown param)
          isNoneSelectedAllSelected: true,
          isInventoryRoutingPage: true,
        } as IInputRow);
      }
      tabRows.push({
        tabName: 'Countries',
        rows: targetedCountriesRows,
      } as ITabRow);

      const targetedRegionsRows = [] as IInputRow[];
      for (let i = 0; i < Destinations.length; i++) {
        const destination = Destinations[i];
        if (destination.BackfillEnabled === EBool.EBool_TRUE) {
          continue;
        }
        const countryGroupCount = Object.values(destination.targetingCountryGroupList).filter(
          (item) => item.selected,
        ).length;
        const targetingCountryGroupsName = 'TargetingCountryGroupIDs' as DestinationTargetFieldKeys;
        const targetingCountryGroupsIsAllowedName =
          'TargetingCountryGroupIDsIsAllowed' as DestinationInclusionFieldKeys;
        const isAllowed = destination[targetingCountryGroupsIsAllowedName] === EAllowStatus.ALLOW;

        const currValues = destination[targetingCountryGroupsName]
          .split(',')
          .filter((v: string) => v.length);
        let disabledTargetingCountryGroupValues = this.genDisabledDestinationValues(
          targetingCountryGroupsName,
          targetingCountryGroupsIsAllowedName,
        );
        const allOtherSelectedCountryGroups = this.getAllCurrentSelectedValues(
          targetingCountryGroupsIsAllowedName,
          targetingCountryGroupsName,
          i,
        );
        if (isAllowed) {
          disabledTargetingCountryGroupValues = allOtherSelectedCountryGroups.filter(
            (val: string) => !currValues.includes(val),
          );
        }

        targetedRegionsRows.push({
          renderType: 'custom',
          customRender: () => {
            return this.renderAllRegionsDialog({
              renderType: 'MaterialDropdown',
              title1: destination.Name,
              materialDropdownTitle: countryGroupCount === 1 ? 'Region' : 'Regions',
              value1: genTargetingCountryGroupListFromSelectedAndDisable(
                publisherCountryGroups,
                destination[targetingCountryGroupsName],
                disabledTargetingCountryGroupValues,
              ),
              handleChange1: (values: IMenuList) => {
                const newVals = this.getGeoValsFromList('targetingCountryGroupList', values)
                  .split(',')
                  .filter((v: string) => v.length);
                const filteredCSVals = this.filterExcludedField(
                  currValues,
                  newVals,
                  targetingCountryGroupsName as DestinationTargetFieldKeys,
                  targetingCountryGroupsIsAllowedName,
                  isAllowed,
                );
                if (filteredCSVals === null) {
                  return;
                }
                const isDeselecting =
                  currValues.length >
                  filteredCSVals.split(',').filter((v: string) => v.length).length;
                if (
                  isDeselecting ||
                  this.isUniqueDestinationValue(
                    targetingCountryGroupsName as DestinationTargetFieldKeys,
                    filteredCSVals,
                    currValues,
                    targetingCountryGroupsIsAllowedName,
                  )
                ) {
                  this.handleChangeDestinationField(
                    targetingCountryGroupsName as DestinationTargetFieldKeys,
                    i,
                    filteredCSVals,
                    isDeselecting,
                    values,
                  );
                }
              },
              isActiveValue1: () => destination.TargetingCountryGroupIDs !== '',
              getActiveTag1: () => '',
              value2: isAllowed,
              handleChange2: () =>
                this.handleChangeDestinationInclusion(
                  targetingCountryGroupsIsAllowedName,
                  i,
                  isAllowed ? EAllowStatus.DENY : EAllowStatus.ALLOW,
                ),
              // if no country groups are selected, all country groups are selected by default
              isNoneSelectedAllSelected: true,
              showModalButton: i === firstNonBackfillIndex,
              modalButton: (
                <ModelSecondaryButton
                  onClick={() => this.setState({ openRegionSelectTable: true })}
                  disabled={!writeAuthorization.isAuthorized}
                >
                  See ALL Regions
                </ModelSecondaryButton>
              ),
              isInventoryRoutingPage: true,
              disableSelectAll: true,
            });
          },
          title1: destination.Name,
          isActiveValue1: () => destination.TargetingCountryGroupIDs !== '',
          getActiveTag1: () => '',
          isInventoryRoutingPage: true,
        } as IInputRow);
      }
      tabRows.push({
        tabName: 'Regions',
        rows: targetedRegionsRows,
      } as ITabRow);

      const localTargetingRows = [] as IInputRow[];
      for (let i = 0; i < Destinations.length; i++) {
        const destination = Destinations[i];
        if (destination.BackfillEnabled === EBool.EBool_TRUE) {
          continue;
        }
        const isAllowedName = 'LocalTargetingIsAllowed';
        const isAllowed = destination[isAllowedName] === EAllowStatus.ALLOW;
        localTargetingRows.push({
          renderType: 'custom',
          customRender: () => this.renderLocalTargetingPanel(destination, i, isAllowed),
          title1: destination.Name,
          field1: '',
          value1: destination.LocalTargeting,
          handleChange1: noopVoid,
          isActiveValue1: () => destination.localTargetingParameters.length !== 0,
          getActiveTag1: () => '',
          isInventoryRoutingPage: true,
        } as IInputRow);
      }
      tabRows.push({
        tabName: 'Local Targeting',
        rows: localTargetingRows,
      });

      return tabRows;
    };

    generateStreamTypeRows = (): IInputRow[] => {
      const streamTypeRows = [] as IInputRow[];
      for (let i = 0; i < this.state.Destinations.length; i++) {
        const destination = this.state.Destinations[i];
        if (destination.BackfillEnabled === EBool.EBool_TRUE) {
          continue;
        }
        streamTypeRows.push({
          renderType: 'SimpleSingleSelect',
          simpleSelectItems: livestreamOptions || [],
          title1: destination.Name,
          field1: 'TargetingLivestream',
          value1: destination.TargetingLivestream,
          handleChange1: (e) => this.handleChangeLivestream(e.target.value, i),
          isActiveValue1: () => destination.TargetingLivestream !== 0,
          getActiveTag1: () => ' ',
          disabled1: this.props.readOnly,
          isInventoryRoutingPage: true,
        } as IInputRow);
      }
      return streamTypeRows;
    };

    generateWseatRows = (): IInputRow[] => {
      const targetFieldName = 'TargetingWSeat' as DestinationTargetFieldKeys;
      const wseatRows = [] as IInputRow[];
      for (let i = 0; i < this.state.Destinations.length; i++) {
        const destination = this.state.Destinations[i];
        if (destination.BackfillEnabled === EBool.EBool_TRUE) {
          continue;
        }
        wseatRows.push({
          renderType: 'AutocompleteAndIncludeRow',
          title1: destination.Name,
          field1: targetFieldName,
          value1: destination.TargetingWSeat,
          handleChange1: (e) => {
            const currValues = destination[targetFieldName as DestinationTargetFieldKeys]
              .split(',')
              .filter((v: string) => v.length);
            const isDeleting =
              destination[targetFieldName].split(',').filter((v: string) => v.length).length >
              e.target.value.split(',').filter((v: string) => v.length).length;
            if (
              isDeleting ||
              this.isUniqueDestinationValue(targetFieldName, e.target.value, currValues)
            ) {
              this.handleChangeDestinationField(targetFieldName, i, e.target.value, isDeleting);
            }
          },
          isActiveValue1: () => destination.TargetingWSeat !== '',
          getActiveTag1: () => ' ',
          placeholderText: 'Enter WSeat here, comma separated',
          disabled1: this.props.readOnly,
          isInventoryRoutingPage: true,
        } as IInputRow);
      }
      return wseatRows;
    };

    generatePrivacyPanelRows = (): ITabRow[] => {
      const coppaRows = [] as IInputRow[];
      const latRows = [] as IInputRow[];
      const ccpaRows = [] as IInputRow[];

      for (let i = 0; i < this.state.Destinations.length; i++) {
        const destination = this.state.Destinations[i] as IDestination;
        coppaRows.push({
          renderType: 'SimpleSingleSelect',
          simpleSelectItems: coppaOptions || [],
          title1: destination.Name,
          field1: 'TargetingCoppa',
          value1: destination.TargetingCoppa,
          handleChange1: (e) =>
            this.handleChangeDestinationField('TargetingCoppa', i, e.target.value),
          isActiveValue1: () => destination.TargetingCoppa !== TargetingCoppaAll,
          getActiveTag1: () => '',
        } as IInputRow);
        latRows.push({
          renderType: 'SimpleSingleSelect',
          simpleSelectItems: latOptions || [],
          title1: destination.Name,
          field1: 'TargetingLimitedAdTracking',
          value1: destination.TargetingLimitedAdTracking,
          handleChange1: (e) =>
            this.handleChangeDestinationField('TargetingLimitedAdTracking', i, e.target.value),
          isActiveValue1: () => destination.TargetingLimitedAdTracking !== TargetBoolTypeAll,
          getActiveTag1: () => '',
        } as IInputRow);
        ccpaRows.push({
          renderType: 'SimpleSingleSelect',
          simpleSelectItems: ccpaOptions || [],
          title1: destination.Name,
          field1: 'TargetingCoppa',
          value1: destination.TargetingCCPA,
          handleChange1: (e) =>
            this.handleChangeDestinationField('TargetingCCPA', i, e.target.value),
          isActiveValue1: () => destination.TargetingCCPA !== TargetingCCPAAll,
          getActiveTag1: () => '',
        } as IInputRow);
      }

      return [
        {
          tabName: 'COPPA',
          rows: coppaRows,
        },
        {
          tabName: 'Limited Ad Tracking',
          rows: latRows,
        },
        {
          tabName: 'CCPA',
          rows: ccpaRows,
        },
      ];
    };

    renderTargetingParameters() {
      const { classes } = this.props;
      const activeParams = this.findActiveTargetingParams()
        .filter((p: string) => p.length)
        .map((param: string) => {
          if (param === 'LocalTargeting') {
            param = 'TargetingLocal';
          }
          return param.slice(9, param.length);
        }); // remove the word targeting from param
      const AppPanel = {
        title: 'App',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        disableActiveTags: true,
        rows: [...this.generateAppBundleRows()],
      } as IAccordionPanel;
      const ContentPanel = {
        title: 'Content',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        disableActiveTags: true,
        enableTabs: true,
        rows: [],
        tabRows: [...this.generateContentRows()],
      } as IAccordionPanel;
      const DealPanel = {
        title: 'Deals',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        disableActiveTags: true,
        enableTabs: true,
        rows: [],
        tabRows: [...this.generateDealIDRows()],
      } as IAccordionPanel;
      const DevicePanel = {
        title: 'Device',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        disableActiveTags: true,
        enableTabs: true,
        rows: [],
        tabRows: [...this.generateDeviceRows()],
      } as IAccordionPanel;
      const EndpointParams = {
        title: 'Endpoint Param',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        disableActiveTags: true,
        enableTabs: true,
        rows: [],
        tabRows: [...this.generateEndpointParamRows()],
      } as IAccordionPanel;
      const StreamTypePanel = {
        title: 'Stream Type',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        disableActiveTags: true,
        rows: [...this.generateStreamTypeRows()],
      } as IAccordionPanel;
      const WseatPanel = {
        title: 'Wseat',
        panelInactiveRowTag: 'Inactive',
        panelActiveChipTitle: 'Active',
        disableActiveTags: true,
        rows: [...this.generateWseatRows()],
      } as IAccordionPanel;
      const GeoPanel = {
        title: 'Geo',
        panelInactiveRowTag: 'All Geos',
        panelActiveChipTitle: 'Active',
        tabRows: [...this.generateGeoRows()],
        enableTabs: true,
        rows: [],
      } as IAccordionPanel;
      const PrivacyPanel = {
        title: 'Privacy',
        panelInactiveRowTag: 'All Values',
        panelActiveChipTitle: 'Active',
        enableTabs: true,
        tabRows: [...this.generatePrivacyPanelRows()],
        rows: [],
      } as IAccordionPanel;

      const panels = [
        AppPanel,
        ContentPanel,
        DealPanel,
        DevicePanel,
        EndpointParams,
        GeoPanel,
        PrivacyPanel,
        StreamTypePanel,
        WseatPanel,
      ];

      return (
        <Grid item className={classes.maxWidthGrid}>
          {activeParams.length > 1 &&
            !this.state.FreewheelPublisherID && ( // freewheel inventory routes can have multiple params but must have a fallback
              <Typography className={this.props.classes.insideAccordionTextRed}>
                {`Only 1 Targeting Parameter may be active for all destinations. ${activeParams.join(
                  ', ',
                )} are currently active.`}
              </Typography>
            )}
          <MultiAccordion
            title='Targeting Parameters'
            subtitle=''
            panels={panels}
            disableEdit={!this.hasWriteRights().isAuthorized}
            forcePanelsOpen={false}
          />
        </Grid>
      );
    }

    renderPercentageRequests() {
      const { classes } = this.props;

      let totalPercentage = 0;
      if (this.state.Destinations.length) {
        totalPercentage = this.state.Destinations.map(
          (route: IDestination) => route.ShareOfRequests,
        ).reduce((prev: number, curr: number) => prev + curr);
      }

      return (
        <Grid
          container
          direction='column'
          className={classes.maxWidthGrid}
          style={{
            backgroundColor: '#ffffff',
            padding: '8px 8px 0px 8px',
            borderRadius: 2,
          }}
        >
          {/* title row */}
          <Grid item className={this.props.classes.requestPercentageGrid}>
            <Grid container direction='row' justify='space-between' alignItems='center'>
              <Grid item>
                <Typography className={this.props.classes.typographyFontBold}>
                  Destination ID
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  className={this.props.classes.typographyFontBold}
                  style={{ marginRight: 45 }}
                >
                  Destination Name
                </Typography>
              </Grid>
              <Grid item>
                <Typography className={this.props.classes.typographyFontBold}>
                  % of Requests
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Divider />
          {/* destination rows */}
          {this.state.Destinations.map((destination: IDestination, i: number) => {
            return (
              <>
                <Grid item className={this.props.classes.requestPercentageGrid}>
                  <Grid container direction='row' justify='space-between' alignItems='center'>
                    <Grid item>
                      <Typography className={this.props.classes.typographyFont}>
                        {destination.ID === 0 ? 'New' : destination.ID}
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography
                        className={
                          destination.DestinationType === DestinationTypeVastURL &&
                          destination.Name === ''
                            ? this.props.classes.typographyFontRed
                            : this.props.classes.typographyFont
                        }
                      >
                        {destination.Name === '' ? 'Enter a destination name' : destination.Name}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      style={{
                        maxWidth: 50,
                      }}
                    >
                      <FocusedTextfield
                        fullWidth
                        multiline
                        endAdornment={'%'}
                        placeholder='Enter %'
                        name={i.toString()}
                        disabled={destination.BackfillEnabled === EBool.EBool_TRUE}
                        value={destination.ShareOfRequests.toString()}
                        onChange={this.handleChangeRequestPercentage}
                        enableAlignRight={true}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Divider />
              </>
            );
          })}
          {/* total row */}
          <Grid item className={this.props.classes.requestPercentageGrid}>
            <Grid container direction='row' justify='space-between' alignItems='center'>
              <Grid item>
                <Typography className={this.props.classes.typographyFontBold}>Total</Typography>
              </Grid>
              <Grid item>
                <Typography
                  className={
                    totalPercentage !== 100
                      ? this.props.classes.typographyFontBoldRed
                      : this.props.classes.typographyFontBold
                  }
                >
                  {`${totalPercentage}%`}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      );
    }

    deleteCountryGroupFunc = (countryGroupID: string, reloadBidder: boolean) => {
      const { publisherCountryGroups } = this.state;
      const foundCountryGroup = publisherCountryGroups.find(
        (countryGroup) => countryGroup.ID.toString() === countryGroupID,
      );

      if (foundCountryGroup) {
        const clonedPublisherCountryGroups = cloneDeep(publisherCountryGroups);
        const filteredPublisherCountryGroups = clonedPublisherCountryGroups.filter(
          (countryGroup) => countryGroup.ID !== foundCountryGroup.ID,
        );

        const updatedDestinations = this.deleteCountryGroupFromDestinations(
          foundCountryGroup.ID.toString(),
        );

        deleteCountryGroup(foundCountryGroup).then(() => {
          this.setState(
            {
              openRegionCreateEditDialog: false,
              openRegionSelectTable: false,
              publisherCountryGroups: filteredPublisherCountryGroups,
              Destinations: updatedDestinations,
              updatingCountryGroup: false,
              snackbarMessage: 'Sucessfully deleted country group',
              snackbarError: false,
              snackbarWarning: false,
            },
            reloadBidder ? this.updateCountryGroupsByPublisherID : undefined,
          );
        });
      }

      return Promise.resolve(undefined);
    };

    renderRegionListTableDialog = () => {
      const { publisherCountryGroups, updatingCountryGroup } = this.state;

      const listTableColumns: IListTableColumn[] = [
        {
          field: 'Name',
          title: 'Region Name',
          renderType: 'modal3',
          searchable: true,
          maxWidth: '200px',
        },
        {
          field: 'CountriesTargeted',
          title: 'Countries Targeted',
          renderType: 'normal',
          searchable: false,
          maxWidth: '100px',
        },
        { field: 'Actions', title: 'Actions', renderType: 'delete', searchable: false },
      ];

      const listTableData: ICountryGroupRowData[] = publisherCountryGroups.map(
        (countryGroup: ICountryGroup) => {
          return {
            ID: countryGroup.ID.toString(),
            Name: countryGroup.Name,
            CountriesTargeted:
              (countryGroup.CountryIsos && countryGroup.CountryIsos.split(',').length) || 0,
          };
        },
      );

      return (
        <Grid item style={{ margin: '20px 15px 5px 15px', width: '97%' }}>
          <ListTable
            title={''}
            columns={listTableColumns}
            data={listTableData}
            isUpdating={updatingCountryGroup}
            handleSetUpdating={this.handleSetUpdatingCountryGroup}
            handleDeleteItem={(countryGroupID: string) =>
              this.deleteCountryGroupFunc(countryGroupID, true)
            }
            handleOpenModal3={this.handleOpenRegionSelectDialog}
            fixedEnabled={true}
            renderCustomToolbar={this.renderCustomToolbar}
            pageSize={10}
            readRoleName={'read_inventory_route'}
            writeRoleName={'write_inventory_route'}
          />
        </Grid>
      );
    };

    renderCreateEditRegionDialog = () => {
      const { classes, session, user } = this.props;
      const {
        createEditRegionID,
        createEditRegionList,
        createEditRegionName,
        errors,
        openRegionCreateEditDialog,
        commonRegionGroups,
      } = this.state;
      const writeAuthorization = IS_AUTHORIZED(['write_inventory_route'], user.user);

      const newCountryIsos = Object.keys(createEditRegionList).filter(
        (key) => createEditRegionList[key].selected,
      );
      const newCountryGroup = {
        CountryIsos: newCountryIsos.map((countryIso) => countryIso.toUpperCase()).join(','),
        Name: createEditRegionName,
        PublisherID: parseInt(session.publisher.ID, 10),
      } as ICountryGroup;

      // clicking on pre-selectable common region selects all default countries in that region
      const onCommonRegionClick = (countryGroup: ICountryGroup) => {
        this.setState({
          createEditRegionList: generateCountryMenuListFromIsos(
            countryGroup.CountryIsos.split(','),
          ),
          createEditRegionName: countryGroup.Name,
        });
      };

      return openRegionCreateEditDialog ? (
        <Grid item style={{ width: '100%' }}>
          <Dialog
            fullWidth
            maxWidth='sm'
            keepMounted
            open={openRegionCreateEditDialog}
            onClose={() => this.handleAllRegionsModalClose(false, false)}
          >
            <Grid item style={{ width: '100%' }}>
              <Typography
                className={classes.parameterHeaders}
                style={{ marginLeft: 30, marginTop: 30, fontSize: 20 }}
              >
                {!createEditRegionID ? 'Create New Region' : 'Edit Region'}
              </Typography>
              <Grid item style={{ marginLeft: 50 }}>
                <TextField
                  label='Region Name'
                  name='createEditRegionName'
                  value={createEditRegionName}
                  onChange={(e) => this.handleChange(e)}
                  error={!!errors.createEditRegionName}
                  helperText={errors.createEditRegionName}
                />
                <Grid>
                  {(commonRegionGroups || []).map((countryGroup: ICountryGroup) => {
                    return (
                      <Button
                        key={countryGroup.ID}
                        style={{ marginTop: 10 }}
                        onClick={() => onCommonRegionClick(countryGroup)}
                      >
                        {countryGroup.Name}
                      </Button>
                    );
                  })}
                </Grid>
              </Grid>

              <Divider style={{ margin: 10, height: 1, color: 'black' }} />

              <Typography className={classes.headingCategorySubtitle} style={{ paddingLeft: 50 }}>
                Select countries to include in region
              </Typography>
              <Grid item style={{ marginLeft: 50, height: 500 }}>
                <MaterialSearchDropdownMulti
                  forceOpen={true}
                  getValueFromSearchElement={(src: IListItem) => src.title}
                  fontSize='14px'
                  selectAll={true}
                  menuTitle=''
                  list={createEditRegionList}
                  disabled={!writeAuthorization.isAuthorized}
                  onChange={(list) => this.handleChangeList('createEditRegionList', list)}
                  handleMenuAcceptClick={() => null}
                  isNoneSelectedAllSelected={true}
                  keepDropdownOpen={true}
                />
              </Grid>
              <DialogActions>
                <Button
                  autoFocus
                  color='primary'
                  onClick={() => {
                    const regionValidationErrors = validatorFactory(regionValidationSetting)(
                      this.state,
                    );
                    this.handleSaveEditNewRegion(
                      regionValidationErrors,
                      errors,
                      createEditRegionID,
                      newCountryGroup,
                    );
                  }}
                >
                  Save
                </Button>
                <Button
                  autoFocus
                  color='primary'
                  onClick={() => this.handleAllRegionsModalClose(false, true)}
                >
                  Cancel
                </Button>
              </DialogActions>
            </Grid>
          </Dialog>
        </Grid>
      ) : null;
    };

    renderAllRegionsDialog = (regionRow: IInputRow) => {
      const { user } = this.props;
      const { openRegionSelectTable } = this.state;

      const writeAuthorization = IS_AUTHORIZED(['write_inventory_route'], user.user);

      return (
        <Grid item style={{ width: '100%' }}>
          <InputRow rowInfo={regionRow} disableEdit={!writeAuthorization.isAuthorized} />
          {openRegionSelectTable ? (
            <Dialog
              fullWidth
              maxWidth='md'
              keepMounted
              open={openRegionSelectTable}
              onClose={() => this.setState({ openRegionSelectTable: false })}
            >
              {this.renderRegionListTableDialog()}
              <DialogActions>
                <Button
                  autoFocus
                  color='primary'
                  onClick={() => this.handleAllRegionsModalClose(false, false)}
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          ) : (
            this.renderCreateEditRegionDialog()
          )}
        </Grid>
      );
    };

    renderDialog() {
      return (
        <Dialog
          fullWidth
          maxWidth='md'
          keepMounted
          open={this.state.openFallbackModal}
          onClose={() => this.setState({ openFallbackModal: false })}
        >
          <Grid>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                If no destination's targeting matches the parameters in the request, the request
                will not fill. Please confirm to save the route.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => this.setState({ openFallbackModal: false })}
                color='primary'
                autoFocus
                disabled={this.state.updating}
              >
                Cancel
              </Button>
              <Button onClick={this.handleSave} disabled={this.state.updating}>
                Confirm and Save
                <span style={this.state.updating ? { opacity: 1 } : { opacity: 0 }}>
                  &nbsp;
                  <CircularProgress size={12} />
                </span>
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
      );
    }

    renderEndpoint = () => {
      const { classes } = this.props;
      return (
        <Grid
          style={{
            marginLeft: 40,
            marginTop: 25,
            width: '98%',
          }}
        >
          <Grid className={classes.smPaper}>
            <H3>Endpoint Builder</H3>
            <div className='endpoint-url-generator'>
              <p>
                Select the following settings to create the endpoint URL associated with this route.
                If you need more information about {getResellerTitle()} params please check
                out&nbsp;
                {/* NOTE: add rel='noopener' since _blank is a potential security issue https://web.dev/external-anchors-use-rel-noopener/ */}
                <a href={getTechnicalDocumentationWiki()} target='_blank' rel='noopener'>
                  our wiki
                </a>
                &nbsp;or reach out to your {getResellerTitle()} account manager.
              </p>
              {/* Region Select */}
              {hasRoleSuperUser(this.props.user.user) && (
                <>
                  <div className={classes.optionRow}>
                    <Select
                      label='Region *'
                      name='Region'
                      value={this.state.Region}
                      fullWidth
                      onChange={(event: React.ChangeEvent<{ value: string }>) => {
                        this.handleChangeRegionSelect(null, event.target.value);
                      }}
                    >
                      {Regions.map((w) => {
                        return <MenuItem value={w.value}>{w.label}</MenuItem>;
                      })}
                    </Select>
                  </div>
                </>
              )}
              {/* Endpoint builder */}
              <Grid container direction='column'>
                <Grid item>
                  <EndpointBuilder service={this.state.endpointBuilderService} />
                </Grid>
                <Grid item>
                  <Divider style={{ marginBottom: '10px', marginTop: '10px' }} />
                </Grid>
                <Grid item style={{ paddingTop: '20px' }}>
                  {this.renderStitchedUrl()}
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      );
    };

    renderStitchedUrl = () => {
      return (
        <Grid item>
          <Grid item container direction='row' justify='flex-start' alignItems='center'>
            <Grid item>
              <img src='/assets/shared/svg/stitch_arrow.svg' alt='Arrow' />
            </Grid>
            <Grid item style={{ paddingLeft: '10px', marginTop: '-4px' }}>
              <ModelParagraphSubtitle>Endpoint URL</ModelParagraphSubtitle>
            </Grid>
          </Grid>
          <BlueBackground classes={{ root: this.props.classes.paper }}>
            <p style={{ width: 'inherit', wordBreak: 'break-word' }}>{this.state.EndpointURL}</p>
          </BlueBackground>
          <Grid item container direction='row' justify='flex-start' alignItems='center'>
            <Grid item>
              <CopyButton
                style={{
                  fontSize: '15px',
                  backgroundColor: 'rgba(239,239,239,0)',
                  color: getColorTheme('secondaryButtonText'),
                }}
                text='COPY'
                copy={this.state.EndpointURL}
              />
            </Grid>
            {/* disable custom params for now
            <Grid item style={{ paddingLeft: '10px' }}>
              {
                (hasRoleSuperUser(this.props.user.user) || this.hasWriteRights().isAuthorized) &&
                <ModelWhiteButton
                  style={{ color: '#CC5B83' }}
                  onClick={() => {
                    this.setState({
                      openEndpointParamsCustomizeMenu: true,
                    });
                  }}
                  disabled={this.state.updating}>
                  [-] Customize Params Value
                </ModelWhiteButton>
              }
            </Grid>
          */}
          </Grid>
          <Grid item container direction='row' justify='flex-start' alignItems='center'>
            <Grid item style={{ paddingLeft: '10px' }}>
              <p className={this.props.classes.smallText}>
                Trafficking endpoint in your ad server? Please replace macros using&nbsp;
                <a href={getMacrosWiki()} target='_blank' rel='noopener'>
                  our documentation
                </a>
                .
              </p>
            </Grid>
          </Grid>
        </Grid>
      );
    };

    // define tabs and corresponding render functions
    renderTabs(): ReactElement {
      const { user } = this.props;
      const { startingTab } = this.state;
      const tabs: ITab[] = [
        {
          label: 'Settings',
          render: this.renderSettings,
        },
      ];
      if (!isEndpointBuilderDisabled(this.props.session.publisher)) {
        tabs.push({
          label: 'Endpoint',
          render: this.renderEndpoint,
        });
      }
      return (
        <Grid>
          <SettingsTabs
            tabs={tabs}
            marginTop={0}
            maxTabWidth='1200px'
            startingTab={startingTab}
            enableTrackEvents={true}
            user={user.user}
            resource='Routes'
          />
        </Grid>
      );
    }

    getLiveLogs = () => {
      const inventoryRouteID = this.state.ID;
      const destinations = this.state.Destinations;

      if (inventoryRouteID === 0) {
        return;
      }

      this.setState(
        {
          refreshingLiveLogs: true,
        },
        () => {
          const inventoryRouteRequestLogsQuery =
            getInventoryRouteEndpointRequestQuery(inventoryRouteID);

          generalGetLiveLogs<IInventoryRouteRequestData[]>(
            inventoryRouteRequestLogsQuery,
            this.props.session.publisher.ID,
            this.props.user.user.Username,
          ).then(([data, err]) => {
            if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
              this.setState({
                inventoryRouteRequestLiveLogs: data,
                refreshingLiveLogs: false,
                refreshingLiveLogsTimestamp: formatTime(
                  moment(),
                  this.props.user.publisher.Timezone,
                ),
              });
            }
            if (err !== undefined) {
              console.error(err);
              this.setState({
                snackbarMessage: 'Error Live Logs for Inventory Route Request',
                snackbarError: true,
                snackbarWarning: false,
                refreshingLiveLogs: false,
              });
            }
          });

          const inventoryRouteResponseLogsQuery =
            getInventoryRouteEndpointResponseQuery(inventoryRouteID);

          generalGetLiveLogs<IInventoryRouteResponseData[]>(
            inventoryRouteResponseLogsQuery,
            this.props.session.publisher.ID,
            this.props.user.user.Username,
          ).then(([data, err]) => {
            if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
              this.setState({
                inventoryRouteResponseLiveLogs: data,
                refreshingLiveLogs: false,
                refreshingLiveLogsTimestamp: formatTime(
                  moment(),
                  this.props.user.publisher.Timezone,
                ),
              });
            }
            if (err !== undefined) {
              console.error(err);
              this.setState({
                snackbarMessage: 'Error Live Logs for Inventory Route Response',
                snackbarError: true,
                snackbarWarning: false,
                refreshingLiveLogs: false,
              });
            }
          });

          const destinationIDs = destinations.map((destination) => destination.ID);

          const destinationEndpointRequestQueries = destinationIDs.map((destinationID) =>
            getDestinationEndpointRequestQuery(destinationID),
          );
          const destinationEndpointRequestPromises = destinationEndpointRequestQueries.map(
            (query) => {
              return generalGetLiveLogs<IDestinationRequestData[]>(
                query,
                this.props.session.publisher.ID,
                this.props.user.user.Username,
              );
            },
          );
          Promise.all(destinationEndpointRequestPromises)
            .then((data) => {
              const destinationRequestLiveLogs = data.map(
                (datum) => datum[0],
              ) as IDestinationRequestData[][];
              if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
                this.setState({
                  destinationRequestLiveLogs,
                  refreshingLiveLogs: false,
                  refreshingLiveLogsTimestamp: formatTime(
                    moment(),
                    this.props.user.publisher.Timezone,
                  ),
                });
              }
            })
            .catch((err) => {
              console.error(err);
              this.setState({
                snackbarMessage: 'Error Live Logs for Destination Request',
                snackbarError: true,
                snackbarWarning: false,
                refreshingLiveLogs: false,
              });
            });

          const destinationEndpointResponseQueries = destinationIDs.map((destinationID) =>
            getDestinationEndpointResponseQuery(destinationID),
          );
          const destinationEndpointResponsePromises = destinationEndpointResponseQueries.map(
            (query) => {
              return generalGetLiveLogs<IDestinationResponseData[]>(
                query,
                this.props.session.publisher.ID,
                this.props.user.user.Username,
              );
            },
          );
          Promise.all(destinationEndpointResponsePromises)
            .then((data) => {
              const destinationResponseLiveLogs = data.map(
                (datum) => datum[0],
              ) as IDestinationResponseData[][];
              if (data !== undefined && data !== null && Object.keys(data).length !== 0) {
                this.setState({
                  destinationResponseLiveLogs,
                  refreshingLiveLogs: false,
                  refreshingLiveLogsTimestamp: formatTime(
                    moment(),
                    this.props.user.publisher.Timezone,
                  ),
                });
              }
            })
            .catch((err) => {
              console.error(err);
              this.setState({
                snackbarMessage: 'Error Live Logs for Destination Response',
                snackbarError: true,
                snackbarWarning: false,
                refreshingLiveLogs: false,
              });
            });
        },
      );
    };

    renderLiveLogsForInventoryRoutes() {
      const { classes } = this.props;
      const {
        ID,
        inventoryRouteRequestLiveLogs,
        inventoryRouteResponseLiveLogs,
        refreshingLiveLogs,
        refreshingLiveLogsTimestamp,
      } = this.state;

      if (ID === 0) {
        return <></>;
      }

      return (
        <LiveLogsWrapper
          useV3={true}
          textColor='white'
          backgroundColor='#273653'
          buttonText='Open Route Logs'
          getLiveLogs={() => this.getLiveLogs()}
          refreshingLiveLogs={refreshingLiveLogs}
          refreshingLiveLogsTimestamp={refreshingLiveLogsTimestamp}
          elements={[
            {
              title: 'Inventory Route Request',
              render: (searchFilter: string) => {
                return (
                  <LiveLogsGeneralTable<IInventoryRouteRequestData>
                    publisherTimezone={this.props.session.publisher.Timezone}
                    data={filterLiveLogs(inventoryRouteRequestLiveLogs, searchFilter)}
                    columns={[
                      {
                        title: 'Timestamp',
                        field: 'timestamp',
                        searchable: false,
                        width: '40px',
                        cellStyle: { whiteSpace: 'pre-wrap' },
                      },
                      {
                        title: 'Endpoint URI',
                        field: 'endpointURI',
                        searchable: false,
                        cellStyle: { overflowWrap: 'anywhere', width: 600 },
                      },
                    ]}
                    nestedData={[
                      {
                        title: 'HTTP Headers',
                        getData: (row: IInventoryRouteRequestData) => row.httpHeaders,
                        getDataToCopy: (row: IInventoryRouteRequestData) =>
                          JSON.stringify(row.httpHeaders),
                        preFormat: 'json-2',
                      },
                      {
                        title: 'Endpoint Body',
                        getData: (row: IInventoryRouteRequestData) => row.endpointBody,
                        getDataToCopy: (row: IInventoryRouteRequestData) => row.endpointBody,
                        preFormat: 'json',
                      },
                    ]}
                  />
                );
              },
            },
            {
              title: 'Inventory Route Response',
              render: (searchFilter: string) => {
                return (
                  <LiveLogsGeneralTable<IInventoryRouteResponseData>
                    publisherTimezone={this.props.session.publisher.Timezone}
                    data={filterLiveLogs(inventoryRouteResponseLiveLogs, searchFilter)}
                    columns={[
                      {
                        title: 'Timestamp',
                        field: 'timestamp',
                        searchable: false,
                        width: '40px',
                        cellStyle: { whiteSpace: 'pre-wrap' },
                      },
                      {
                        title: 'Endpoint URI',
                        field: 'endpointURI',
                        searchable: false,
                        cellStyle: { overflowWrap: 'anywhere', width: 600 },
                      },
                    ]}
                    nestedData={[
                      {
                        title: 'Device ID',
                        getData: (row: IInventoryRouteResponseData) => row.deviceID,
                        getDataToCopy: (row: IInventoryRouteResponseData) => row.deviceID,
                        preFormat: 'text',
                      },
                      {
                        title: 'Response',
                        getData: (row: IInventoryRouteResponseData) => row.response,
                        getDataToCopy: (row: IInventoryRouteResponseData) => row.response,
                        preFormat: 'xml',
                        isNested: true,
                      },
                      {
                        title: 'Endpoint Body',
                        getData: (row: IInventoryRouteResponseData) => row.endpointBody,
                        getDataToCopy: (row: IInventoryRouteResponseData) => row.endpointBody,
                        preFormat: 'json',
                      },
                    ]}
                  />
                );
              },
            },
          ]}
          classes={classes}
        />
      );
    }

    renderLiveLogsForDestination(idx: number) {
      const { classes } = this.props;
      const { ID, refreshingLiveLogs, refreshingLiveLogsTimestamp } = this.state;
      const destinationRequestLiveLogs = this.state.destinationRequestLiveLogs[idx];
      const destinationResponseLiveLogs = this.state.destinationResponseLiveLogs[idx];

      if (ID === 0) {
        return <></>;
      }

      return (
        <LiveLogsWrapper
          useV3={true}
          buttonText='Open Destination Logs'
          isFixedButton={false}
          textColor='#4952FF'
          getLiveLogs={() => this.getLiveLogs()}
          refreshingLiveLogs={refreshingLiveLogs}
          refreshingLiveLogsTimestamp={refreshingLiveLogsTimestamp}
          elements={[
            {
              title: 'Destination Request',
              render: (searchFilter: string) => {
                return (
                  <LiveLogsGeneralTable<IDestinationRequestData>
                    publisherTimezone={this.props.session.publisher.Timezone}
                    data={filterLiveLogs(destinationRequestLiveLogs, searchFilter)}
                    columns={[
                      {
                        title: 'Timestamp',
                        field: 'timestamp',
                        searchable: false,
                        width: '40px',
                        cellStyle: { whiteSpace: 'pre-wrap' },
                      },
                      {
                        title: 'Request URL',
                        field: 'requestURL',
                        searchable: false,
                        cellStyle: { overflowWrap: 'anywhere', width: 600 },
                      },
                    ]}
                    nestedData={[
                      {
                        title: 'Endpoint Body',
                        getData: (row: IDestinationRequestData) => row.endpointBody,
                        getDataToCopy: (row: IDestinationRequestData) => row.endpointBody,
                        preFormat: 'json',
                      },
                    ]}
                  />
                );
              },
            },
            {
              title: 'Destination Response',
              render: (searchFilter: string) => {
                return (
                  <LiveLogsGeneralTable<IDestinationResponseData>
                    publisherTimezone={this.props.session.publisher.Timezone}
                    data={filterLiveLogs(destinationResponseLiveLogs, searchFilter)}
                    columns={[
                      {
                        title: 'Timestamp',
                        field: 'timestamp',
                        searchable: false,
                        width: '40px',
                        cellStyle: { whiteSpace: 'pre-wrap' },
                      },
                      {
                        title: 'Request URL',
                        field: 'requestURL',
                        searchable: false,
                        cellStyle: { overflowWrap: 'anywhere', width: 600 },
                      },
                    ]}
                    nestedData={[
                      {
                        title: 'Response',
                        getData: (row: IDestinationResponseData) => row.responses,
                        getDataToCopy: (row: IDestinationResponseData) => row.responses,
                        preFormat: 'xml',
                        isNested: true,
                      },
                      {
                        title: 'Endpoint Body',
                        getData: (row: IDestinationResponseData) => row.endpointBody,
                        getDataToCopy: (row: IDestinationResponseData) => row.endpointBody,
                        preFormat: 'json',
                      },
                    ]}
                  />
                );
              },
            },
          ]}
          classes={classes}
        />
      );
    }

    render() {
      const { snackbarMessage, snackbarError, snackbarWarning } = this.state;
      const { readOnly, disableAppBar, classes, user, session, location } = this.props;
      const { pathname } = location;
      return (
        <Panels maxWidth vertical relative minWidthMain>
          <Panel largeHorizontalPadding verticalPadding>
            <ModelTopBar
              title={routeName(pathname)}
              session={session}
              user={user}
              publisher={session.publisher}
              classes={classes}
              delegateElevate={true}
              currentPath={pathname}
              disableTitlePaddingLeft
            />
          </Panel>
          <Panel>{!disableAppBar && this.renderAppBar()}</Panel>
          <Panel scroll largePadding>
            <div style={{ marginTop: disableAppBar ? 0 : 8 }}>
              {/* Live Data */}
              <Grid>
                <LiveData
                  resourceIDs={this.props.currentRoute.ID.toString()}
                  resourceType='InventoryRoute'
                  timezone={this.props.session.publisher.Timezone}
                  publisher={this.props.session.publisher}
                  maxWidth='1200px'
                  location={this.props.location}
                />
              </Grid>
            </div>
            {!readOnly && this.renderTabs()}
            {readOnly && this.renderSettings()}
            <SnackbarView
              open={!!snackbarMessage}
              error={!!snackbarError}
              warning={!!snackbarWarning}
              onClose={this.handleSnackbarClose}
            >
              {snackbarMessage}
            </SnackbarView>
            {this.renderDialog()}
          </Panel>
          {!readOnly && this.renderLiveLogsForInventoryRoutes()}
        </Panels>
      );
    }
  },
);
